import React, { useRef, useState, useCallback, useEffect, useMemo } from 'react';
import { basics, options, colorReplace } from './images';
import {

  mon_background, dual_background, mega_background, 
  egg_background, option_background, tamer_background,
  mon_background_nocost, mega_background_nocost, /*egg_background_nocost,*/ option_background_nocost, tamer_background_nocost,

  ace_backgrounds, dual_backgrounds,
  outlines,
  outlines_nocost,
  outlines_tamer, outline_option, outlines_egg,
  outlines_tamer_nocost, outline_option_nocost, /*outlines_egg_nocost,*/

  cost, cost_egg, cost_dual, cost_blank, cost_option, cost_evo, cost_evo_plain, costs,
  ace_logo, ace_box, arts_box, foil, gold, linkdp,
  new_evo_circles, /* new_evo2_circles, */
  new_evo_wedges,
  bottoms, bottoms_plain, borders, effectboxes,

  // inherits at bottom:
  bottom_evos, bottom_egg_evos,
  inherited_security, inherited_mon_security,
  bottom_property_white, bottom_property_black,

  pen_img,

  lines,
} from './images';

import { applyGradientToFrame, contrastColor, whiteColor, empty } from './util';
import { enterPlainText, custom_1, custom_2, custom_3, custom_4, custom_5, custom_6, custom_7 } from './plaintext';
import { fitTextToWidth, drawBracketedText, writeRuleText, center, textLine, drawRoundedRect,
  gold_text, set_gold_text,
  gold_gradient,
  textColor 
 } from './text';
import banner from './banner.png';
import egg from './egg.png';
import white from './white.png';
import field from './field.png';
import placeholder from './placeholder.png';
import transparent from './transparent.png';
import shieldsmasher from './shieldsmasher.png';
import rampager from './rampager.png';
import featherbackground from './feather-background.png';
import featherling from './featherling.png';
import doublebind from './double-bind.png'
import amy from './amy.png';
import armor_cat from './armorcat.png';
import { CircleAndBlock } from './Components';


//import './styles.css';
import './local-styles.css';
import axios from 'axios';

import { restoreState, SaveState } from './SaveState';
import ImageBrowser from './ImageBrowser';
import GoogleAuth from './GoogleAuth';
import RadioGroup from './RadioGroup';
import { Base64 } from 'js-base64';
import pako from 'pako';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';


const version = "0.8.61"
const latest = "change gradient on rounded-rectangle keywords re @rlvvmc"

// version 0.8.60 = rule text to MyriadProBold (should be SemiBold re: @rlvvmc)
// version 0.8.59   changes to fonts for evo circles, smaller evo circles, evo_cond +/- dopesn't crash on multicards
// version 0.8.58   security text color uses same logic as name text
// version 0.8.57   nimbus font used for people who don't have helvetica; tweak DP numbers; dark blue for counter
// version 0.8.56.x for card types, roboto -> anago font change and spacing routine recommended by @rlvvmc
// version 0.8.55   fix light blue which shouldn't exist at all and old darker blue now really dark and better 🔴🔵🟡🟢🟣⚫⚪, courtesy @rlvvmc; fix zip filenames; no glow on eggs/dual
// version 0.8.54.x debounce and circle shading courtesy of @rlvvmc'
// version 0.8.53   new DUAL frames courtesy of @rlvvmc
// version 0.8.52   only use defaults arts evolve text if there's none
// version 0.8.51   naked circle when using playCost of 'blank'
// version 0.8.50   stop option name overflow; fix font for duel effect; more room for optionCardEffect
// version 0.8.49   for DUALs fix use color and level-shell color
// version 0.8.48   autopopulate all needed fields when clicking "DUAL"
// version 0.8.47   test dual frame
// version 0.8.46   gold text
// version 0.8.45   'egg' and 'blank' and 'dash' costs
// version 0.8.44   addFoil now allows gold border
// version 0.8.43   more work on dual, getting colors, arts evolve box at bottom, border works
// version 0.8.42.x very basic dual card, doesn't handle multi-color
// version 0.8.41.x dual prep
// version 0.8.40.x fix option color on option text (reversion around 0.8.34)
// version 0.8.39.x transparent background option
// version 0.8.38   load sample multi-card
// version 0.8.37.x multiple cards re-implemented in non-stupid way
// version 0.8.36   link DP on options and tamers; won't work on eggs or ACEs
// version 0.8.35   link DP on options
// version 0.8.34   fix scaling of text issues 
// version 0.8.33   burst evolve proper colors, fix transform
// version 0.8.32.  alt Font Delta, use a different font size for special / dna / assembly conditions; reorder
// version 0.8.31   fix digixros length; flip order of artist and author
// version 0.8.30   at last, proper fonts for keywords
// version 0.8.29.x (*italic text*), better handles keywords
// version 0.8.28.x fix bubbleradius and ace text composed on the fly, no autoblue
// version 0.8.27   italics
// version 0.8.26   《 》 for dark blue, or, whatever [bracket] starts bubble text
// version 0.8.25   custom radius
// version 0.8.24   bug fixes: stop [on evolve] from being dark blue; add aceEffect everywhere; stop crashing on old iOS; font guide updates; fugly iOS name font fixed   
// version 0.8.23   finally burst digivolve
// version 0.8.22   specialEvolve and DNAEvolve no longer overlap
// version 0.8.21.x ⸨text⸩ or ((text)) is forced green, and updated ACE box to modern wording
// version 0.8.20.x assembly field added (overlaps with digixros); arbitrary [fields] at start of digixros/link/assembly line
// version 0.8.19.x monsters with security inheriteds have security icons, and 'egg' as cost to force egg icon
// version 0.8.18.x rarity and block icons, finally, and update old cards to allow
// version 0.8.17   new 'USE' label for options, way overdue
// version 0.8.16.x prep for new changes; 'new card' starts out as dupe of current card
// version 0.8.15.x Assembly as green
// version 0.8.14   colored frames, not loading immediately
// version 0.8.13   when linking not green; e.cost fix; all for rainbow is back; rainbow border
// version 0.8.12   +/- buttons for evo conditions
// version 0.8.11.x multi-color circles are back
// version 0.8.9.x  fix bugs in default egg and number parsing; eggs always show eggs, cards can have no play cost
// version 0.8.8.x  no cost outlines for many things, kind of buggy
// version 0.8.7.x  better show all
// version 0.8.6    load images as we walk through the array
// version 0.8.5    load images up again (but only for first image in array)
// version 0.8.4    can iterate over array and save objects
// version 0.8.3    json object now array
// version 0.8.2.x  fix dead link
// version 0.8.1    0 DP shows up as big 0 with no small 000
// version 0.8.0.x  keep image IDs assigned, refresh token automatically, fix CORS
// version 0.7.19   image upload stuff                                                                                                      
// version 0.7.18.x red once-per-turn; proto background uploading; 'Stnd.' as level to evo from
// version 0.7.17.8 font tests; bubble offset slightly changed; font stuff, font guide 3
// version 0.7.17.x fix DP font to use Ayar; right sliver on foreground image gone
// version 0.7.16.x don't let <keywords> be broken across liens no matter how long they are; brackets, either; let background go all the way to the right; other background fixl sliver fix AGAIN
// version 0.7.15   new free text format candidate for link/plug effects; (color) matching the xros and rule; fix digixros going nuts"
// version 0.7.14.x various weird git fixes, author fix, tama fix, ayar fix, ayar offset
// version 0.7.13   artist and author line
// version 0.7.12   fix bug shawndamarbledcat found, where inherits were limited to a single line
// versonm 0.7.11   squish rule text to a single line
// version 0.7.10.x reorder fields a bit to move up evo conditions; move lineSpacing, skipdraw, baselineoffset and specialoffset into blob; foregroud over border
// version 0.7.9.x  set background image, put all checkboxes into JSON blob, white/yellow name now pure black, fix Lv.X text w/Ace frames, new reminder text
// version 0.7.8    bigsize DP in link DP, too
// version 0.7.7.x  increase Lv.N text size; don't wait for fonts for first load
// version 0.7.6.x  trying to properly cache updates so just 1 happens at a time, and 1 always happens at the end"
// version 0.7.5    fix numemon ace bug, trait ordering bug; link fields update; better linkDP checking
// version 0.7.4    multi evo circles back, not multiple bars for 1 trait
// version 0.7.3.x  link monster BETA, fix evo wedges
// version 0.7.2    generate multiple images in a row, BETA, try using a JSON array to see how
// version 0.7.1    have both diamond text and blue brackets at same time
// version 0.7.0    free form parsing becoming more formal, and more crash bugs fixed
// version 0.6.27   fix some slices not drawing; fix some bracketed text not appearing in blue
// version 0.6.26.x make ACE ESS transparent; make egg ESS transparent again
// version 0.6.25.x fix white inherit boxes; effect box improvements; black (white) attribute bar improvements
// version 0.6.24 fix offsets for black bar on eggs; not quite pixel perfect
// version 0.6.23 text inside <tags> isn't broken up; [brackets] at start of line are blue again; digixros multiline; egg logo on eggs
// version 0.6.22 spacing around blue keyword boxes; get rid of right-hand image overflowing by 20 pixels; force missing fields into JSON
// version 0.6.21 optioninherit made, and tamerinherit improved
// version 0.6.20 fix evo circle not loading bug; improve freeform parsing 
// version 0.6.19 black outline on colored text; improved bubble; when digivolviong; overflow number in text; fix restore of old cards
// version 0.6.18 ace frames and alignment fixed
// version 0.6.17 fontsize in JSON
// version 0.6.16 disabling scaling, neue warning
// version 0.6.15 HelveticaNeue instead of AyarKasone for costs
// version 0.6.14 DP number width
// version 0.6.13 put image data into blob
// version 0.6.12 digixros + rule text non-overlap
// verison 0.6.11 more obvious multi-level select; fix helvetica font as backup
// version 0.6.10 hide outline, ace frame
// version 0.6.9  foil frame, ess image
// version 0.6.8  no digi on eggs; offset name on trait-less option/tamer; AyarKasone back for evo; blue keywords a better blue
// version 0.6.7  skinny up two-digit DP number; specialOffset tuneable; rounded corners
// version 0.6.6  try to pixel match both ex2-039 and bt14-014; customize effect height; scale effectbox (but not for options)
// version 0.6.5  fix pixels of effect text and DP and other things to be near-pixel-perfect
// version 0.6.4  massive font upgrade: name, effect/keywords, traits, level all identical to print cards now
// version 0.6.3  fix width on bubble and DNA and multi-line; DNA now uses proper colored box"
// version 0.6.2  handle 'digivolve' as well as 'evolve'; helvetica as backup font; straggling pixels fixed; playcost and evocost offsets broken and then fixed
// version 0.6.1  rainbow colors; zoom; better baseline; proper font on cost; fix shift on play cost when evo
// version 0.6.0  undo; new format; disable classic mode; freeform auto parsed
// version 0.5.10 save cards with versions, color wheels on ESS effects-side
// version 0.5.9  save cards server-side
// version 0.5.8  black/white bar at bottom of name block if any trait
// version 0.5.7  bubble text italicized and rounded and compressed to fit (but also for keywords); rule text now working
// version 0.5.6  rule text box
// version 0.5.5  proper ESS symbols for options and inherit-less tamers; font updates; 'security' defaults to blue use [(security)] for magenta
// version 0.5.4  pie wedges for evo; adjustable font; squeeze text horizontally beyond some threshold                            
// version 0.5.3  aces
// version 0.5.2  megas done, freeform input                                                                                      
// version 0.5.1  Prototype for new modern cards; old functionality may still be around but not tested
// version 0.5.0  Updated many small and some big things that weren't looking right; moving towards modern
// version 0.4.9  "Save image locally" was broken
// version 0.4.8  fix "force clear"
// version 0.4.7  line feeds, more permissive of blue block text
// version 0.4.6  updated link, force draw
// version 0.4.5  3+ colors and others
// version 0.4.4  less errors, fix egg text
// version 0.4.3  multi color, egg.
// version 0.4.2. Better error handling, re-orient custom image

let img_map = [];
img_map[-1] = shieldsmasher;
img_map[-2] = rampager;
img_map[-3] = egg
img_map[-4] = amy;
img_map[-5] = field;
img_map[-6] = armor_cat;
img_map[-7] = featherbackground;
img_map[-8] = featherling;
img_map[-9] = doublebind;

let type;

const settingsText = {
  "x_pos": "image offset, X",
  "y_pos": "image offset, Y",
  "x_scale": "image X scale, %",
  "y_scale": "image Y scale, %",
  "ess_x_pos": "ESS start X, %",
  "ess_y_pos": "ESS start Y, %",
  "ess_x_end": "ESS end X, %",
  "ess_y_end": "ESS end Y, %",
  "fontSize": "font size",
  "foregroundOnTop": "foreground over frame",
  "cardFrame": "draw card frame",
  "effectBox": "pre-BT14 effect box",
  "addFoil": "foil mode, 0 thru 2",
  "goldText": "gold effect on text",
  "aceFrame": "use new frame for ACE/DUAL",
  "coloredFrame": "colored border frame",
  "outline": "include border line",
  "skipDraw": "disabling drawing",
  "lineSpacing": "line spacing",
  "baselineOffset": "move effect baseline up by",
  "specialOffset": "move special evos up by",
  "bubbleRadius": "word bubble radius",
  "altFontDelta": "+/- for custom size for alt evo and xros text"
}
const settingText = (s) => {
  return settingsText[s] || s;
}


const handleUpload = async (image, folder) => {
  if (!image) return;
  if (image.src.startsWith("http")) return;

  const response = await fetch(image.src);
  const blob = await response.blob();
  const image_id = image.id;
  const file = new File([blob], 'uploaded-image.jpg', { type: blob.type });
  const formData = new FormData();
  formData.append('image', file); // Ensure the key matches the server-side 'upload.single('image')'
  formData.append('folder', folder);
  formData.append('image_id', image_id);

  const token = localStorage.getItem('google_token');

  try {
    const response = await axios.post('/api/image/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`,
      },
    });
    console.log("File uploaded to " + folder + " successfully:", response.data);
  } catch (error) {
    console.error("Error uploading file:", error);
  }
}

// handles empty imageOptions object, or incomplete one
function initObject(target, reference) {
  if (!target) return ({ ...reference });
  for (const key in reference) {
    if (!target.hasOwnProperty(key)) {
      target[key] = reference[key];
    }
  }
  return target;
}

function effectBoxScale(source_height, offset) {
  let y_scale = (source_height + Number(offset) - 30) / (source_height)
  return y_scale;
}


const numberFont = "'HelveticaNeue-CondensedBold', 'Nimbus-Sans-Novus'"; 
//'Helvetica Neue Condensed Bold', 'Neue Helvetica BQ', 'Helvetica Neue',
// 'AyarKasone', 'Helvetica'"
//const numberFont = "'HelveticaNeue-CondensedBold'";
//const numberFont = "'Nimbus-Sans-Novus'";
//const numberFont = "ProhibitionRough";
let neue = false; //document.fonts.check(`16px ${numberFont}`);


// stringroundremoved, dec 17







const hasLevel = (type) => {
  return (type === "EGG" || type === "MONSTER" || type === "MEGA" || type === "ACE" || type === "LINK" || type === "DUAL");
}
const levelHeight = (type) => {
  // ACE should be in here!
  if (type === "EGG") return - 110;
  if (type === "MEGA" || type === "LINK") return 500;
  if (type === "DUAL") return -300;
  return 0;
}
const hasEvo = (type) => {
  return (type === "MONSTER" || type === "MEGA" || type === "ACE" ||
    type === "TAMER" || type === "TAMERINHERIT" || type === "LINK" || type === "DUAL");
}
const hasDP = (type) => {
  return (type === "MONSTER" || type === "MEGA" || type === "ACE" || type === "LINK" || type === "DUAL");
}


// not using radius
const setupRoundedCorners = (ctx, width, height, radius) => {
  radius = 200;
  ctx.beginPath();
  ctx.moveTo(radius, 0);
  ctx.lineTo(width - radius, 0);
  ctx.quadraticCurveTo(width, 0, width, radius);
  ctx.lineTo(width, height - radius);
  ctx.quadraticCurveTo(width, height, width - radius, height);
  ctx.lineTo(radius, height);
  ctx.quadraticCurveTo(0, height, 0, height - radius);
  ctx.lineTo(0, radius);
  ctx.quadraticCurveTo(0, 0, radius, 0);
  ctx.closePath();
  ctx.clip();
};

const starter_text_empty = `[{
  "name": {
    "english": "Tama"
  },
  "color": "Red",
  "cardType": "Digi-Egg",
  "playCost": "-",
  "cardLv": "Lv.2",
  "cardNumber": "X-01",
  "dp": "-",
  "evolveCondition": [
    {
      "color": "",
      "cost": "",
      "level": ""
    }
  ],
  "form": "In-Training",
  "attribute": "",
  "type": "",
  "rarity": "C",
  "block": "04",

  "specialEvolve": "-",
  "dnaEvolve": "-",
  "digiXros": "",
  "assembly": "",
  "burstEvolve": "-",
  
  "linkRequirement": "-",
  "linkDP": "-",
  "linkEffect": "-",

  "effect": "-",
  "securityEffect": "-",
  "evolveEffect": "-",


  "rule": "",

  "aceEffect": "",
  "artist": "-",
  "author": "-",
  "imageOptions": {
    "background_url": "",
    "foreground_url": "",
    "x_pos": 0,
    "y_pos": 0,
    "x_scale": 95,
    "y_scale": 95,
    "ess_x_pos": 40,
    "ess_y_pos": 40,
    "ess_x_end": 50,
    "ess_y_end": 50,
    "fontSize": 90.5,
    "lineSpacing": 10,
    "baselineOffset": 0,
    "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
    "foregroundOnTop": false,
    "cardFrame": true,
    "effectBox": false,
    "addFoil": 0,
    "goldText": false,
    "aceFrame": true,
    "coloredFrame": false,
    "outline": true,
    "skipDraw": false
  }
}]`;


const starter_text_0 = ` {
    "name": {  "english": "Doggie Dagger"  },
    "color": "Green",
    "cardType": "Digi-Egg",
    "cardLv": "Lv.2",
    "cardNumber": "CS2-01",
    "dp": "-",
    "evolveCondition": [],
    "effect": "-",
    "playCost": "-",
    "form": "In-Training",
    "attribute": "Data",
    "type": "Sword",
    "rarity": "C",
    "block": "03",
    "evolveEffect": "[Your Turn] While you have a red Monster or Tamer in play, all your Monsters gain +1000 DP.",
    "cardNumber": "CS-01",
    "imageOptions":{
      "background_url": "", "foreground_url": "-3", "x_pos": 0, "y_pos": 0, "x_scale": 95, "y_scale": 95,
      "ess_x_pos": 40, "ess_y_pos": 40, "ess_x_end": 50, "ess_y_end": 50,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": false,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": true,
            "coloredFrame": false,
            "outline": true,
            "skipDraw": false

    }
}`;

const starter_text_1 = `
     ʟᴠ.4 — Armored Cat — CS1-18
[Champion | Data | Shield] [Yel.]
Play cost: 6 | Evolution: 3 from Lv.3 [Yel.]
     6000 DP

＜Armor Purge＞
     · Inherited Effect:
`

const starter_text_1a = `  {
    "name": {  "english": "Shield Smasher"  },
    "color": "Blue/Red",
    "cardType": "Digimon",
    "playCost": "12",
    "dp": "9000",
    "evolveCondition": 
      [{ "color": "Blue/Red", "cost": "4", "level": "5" }],
    "cardLv": "Lv.6",
    "form": "Ultimate",
    "attribute": "Data",
    "type": "Sword",
    "effect": "＜Vortex＞ \uff1cSecurity Attack +1\uff1e [Your Turn] When this monster attacks a Monster with [Shield] in its name, this Monster gets +5000 DP until the end of your opponent's turn.\\n[(Security)] [All Turns] Your Monsters get +1000 DP.",
    "evolveEffect": "-",
    "securityEffect": "-",
    "specialEvolve": "-",
    "digiXros": "[DigiXros -3] [Axe Raider] x [Pikachu]",
    "assembly": "-",
    "aceEffect": "",
    "dnaEvolve": "-",
    "burstEvolve": "-",
    "rarity": "Rare",
    "block": "05",
    "rule": "[Rule] Trait: Has the [Virus] attribute",
    "cardNumber": "CS2-11",
    "imageOptions":{
      "background_url": "", "foreground_url": "-1", "x_pos": 0, "y_pos": 0, "x_scale": 95, "y_scale": 95,
      "ess_x_pos": 40, "ess_y_pos": 40, "ess_x_end": 50, "ess_y_end": 50,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": false,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": true,
            "coloredFrame": false,
            "outline": true,
            "skipDraw": false

    }
  }`;

const starter_text_1b = `  {
    "name": {  "english": "Rampager"  },
    "color": "Yellow/Blue",
    "cardType": "Monster",
    "playCost": "14",
    "dp": "14000",
    "evolveCondition": 
      [{ "color": "Yellow", "cost": "5", "level": "6" },
       { "color": "Blue", "cost": "5", "level": "6" },
       { "color": "Green", "cost": "5", "level": "6" } ],
    "cardLv": "Lv.7",
    "securityEffect": "-",
    "form": "Ultimate",
    "attribute": "Virus",
    "type": "Sword/Shield",
    "specialEvolve": "-",
    "effect": "\uff1cBlast DNA Digivolve (Colossal Sword + Onyx Shield)\uff1e\\n＜Resurrect＞ ＜Piercing＞ \\n [When Thinking] Delete all of your opponent's Monsters with the biggest level. Then delete all of your opponent's Monsters with the smallest DP.",
    "evolveEffect": "-",
    "dnaEvolve": "[DNA Digivolve] Yellow Lv.6 + Blue Lv.6\u00a0: Cost 0",
    "digiXros": "-",
    "assembly": "-",
    "aceEffect": "Overflow \uff1c-5\uff1e (As this card moves from the field or\\nunder a card to an area other than those, lose 5 memory.)",
    "burstEvolve": "-",
    "rarity": "Secret Rare",
    "block": "05",
    "rule": "",
    "cardNumber": "CS2-18",
    "imageOptions":{
      "background_url": "", "foreground_url": "-2", "x_pos": 0, "y_pos": 0, "x_scale": 95, "y_scale": 95,
      "ess_x_pos": 40, "ess_y_pos": 40, "ess_x_end": 50, "ess_y_end": 50,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": false,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": true,
            "coloredFrame": false,
            "outline": true,
            "skipDraw": false

    }
  }`;

const starter_text_1c = `{
  "name": {
    "english": "FairyFeatherlink"
  },
  "color": "Green",
  "cardType": "Monster",
  "playCost": "3",
  "dp": "1000",
  "evolveCondition":
        [{ "color": "Green", "cost": 1, "level": "2" }],
  "cardLv": "Lv.3",
  "form": "Rookie",
  "attribute": "Bird",
  "type": "Spellcaster",
  "rarity": "Special",
  "block": "03",
  "specialEvolve": "-",
  "effect": "[Your Turn] [Once Per Turn] When this Monster gets linked, You may suspend 1 other Monster with DP less than or equal to this Monster.",
  "linkRequirement": "[Link] [Bird] trait: Cost 1",
  "linkDP": "1500",
  "linkEffect": "＜Dodge＞ (*When this Monster would leave the field, you may suspend it to prevent that deletion.*)",
  "securityEffect": "-",
  "rule": "",
  "digiXros": "-",
  "assembly": "-",
  "aceEffect": "",
  "dnaEvolve": "-",
  "burstEvolve": "-",
  "cardNumber": "CS3-02",
  "imageOptions": {
    "background_url": "-7", "foreground_url": "-8",
    "x_pos": "9",
    "y_pos": "-16",
    "x_scale": "84",
    "y_scale": "84",
    "ess_x_pos": "12",
    "ess_y_pos": "24",
    "ess_x_end": 50,
    "ess_y_end": 50,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": true,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": true,
            "coloredFrame": false,
            "outline": true,
            "skipDraw": false
  },
  "author": "",
  "artist": ""
}`;

const starter_text_2 = `  {
  "name": {      "english": "Double Bind"    },
  "color": "Yellow/Green",
  "cardType": "Option",
  "playCost": "7",
  "attribute": "Rock",
  "effect": "[Main] Suspend 2 of your opponent's Monsters. Then, return 1 of your opponent's suspended Monster to its owner's hand.",
  "securityEffect": "[Security] Activate this card's [Main] effect.",
  "evolveEffect": "-",
  "digiXros": "-",
  "assembly": "-",
  "aceEffect": "",
  "rarity": "Super Rare", 
  "block": "05",
  "rule": "",
  "cardNumber": "CS1-13",
  "linkRequirement": "-",
  "linkDP": "-",
  "linkEffect": "-",
    "imageOptions":{
      "background_url": "", "foreground_url": "-9", "x_pos": 0, "y_pos": 0, "x_scale": 95, "y_scale": 95,
      "ess_x_pos": 40, "ess_y_pos": 40, "ess_x_end": 50, "ess_y_end": 50,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": false,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": true,
            "coloredFrame": false,
            "outline": true,
            "skipDraw": false

    }
  }`;

const starter_text_3 = `   {
    "name": {   "english": "Aggressive Amy"   },
    "color": "Blue/Red",
    "cardType": "Tamer",
    "playCost": "3",
    "type": "Data",
    "effect": "[Start of Your Main Phase] If you have a monster, gain 1 memory.\\n[Main] By suspending this Tamer, until the end of your opponent's turn, 1 of your opponent's Monsters gains \\"[Start of Your Main Phase] Attack with this Monster\\".",
    "securityEffect": "[Security] Play this card without paying the cost.",
    "evolveEffect": "-",
    "digiXros": "-",
    "assembly": "-",
    "aceEffect": "",
    "rarity": "Rare",
    "block": "05",
    "rule": "",
    "cardNumber": "CS2-17",
    "imageOptions":{
      "background_url": "", "foreground_url": "-4", "x_pos": 0, "y_pos": 0, "x_scale": 95, "y_scale": 95,
      "ess_x_pos": 40, "ess_y_pos": 0, "ess_x_end": 80, "ess_y_end": 40,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": false,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": true,
            "coloredFrame": false,
            "outline": true
    }
    }`;

    const starter_text_4 = `   {
    "name": {   "english": "Dual Mon / Shark Lazers"   },
    "color": "Purple",
    "optionCardColourRequirement": "Red/Blue",
    "cardType": "Monster / Option",
    "playCost": "5",
    "dp": "8000",
    "cardLv": "Lv.5",
        "evolveCondition": 
      [{ "color": "Purple", "cost": "3", "level": "4" } ],
    "type": "Shark",
    "effect": "[Counter] Gain 5 memory.",
    "dualEffect": "[Arts Digivolve]",
    "optionCardEffect": "＜Use Req. 《Play cost 5 Tamer》＞\\n[Main] Delete 1 of your Monsters.",
    "securityEffect": "",
    "evolveEffect": "-",
    "digiXros": "-",
    "assembly": "-",
    "aceEffect": "",
    "rarity": "Ultimate Rare",
    "block": "06",
    "rule": "",
    "cardNumber": "D3-23",
    "imageOptions":{
      "background_url": "", "foreground_url": "", "x_pos": 0, "y_pos": 0, "x_scale": 95, "y_scale": 95,
      "ess_x_pos": 40, "ess_y_pos": 0, "ess_x_end": 80, "ess_y_end": 40,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": false,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": false,
            "coloredFrame": false,
            "outline": true
    }
    }`;

// we only need this text for the dump of all sample cards; the base text exists to show off how you can make cards from plain text
const starter_text_1_backup = `{
    "name": {
      "english": "Armored Cat"
    },
    "color": "Yellow",
    "cardType": "Digimon",
    "playCost": "6",
    "dp": "6000",
    "evolveCondition": [
      {
        "level": "3",
        "cost": "3",
        "color": "Yellow"
      }
    ],
    "cardLv": "Lv.4",
    "form": "Champion",
    "attribute": "Data",
    "type": "Shield",
    "rarity": "",
    "specialEvolve": "-",
    "dnaEvolve": "-",
    "digiXros": "",
    "assembly": "",
    "burstEvolve": "-",
    "effect": "＜Armor Purge＞",
    "evolveEffect": "XXX",
    "securityEffect": "",
    "linkDP": "-",
    "linkRequirement": "",
    "linkEffect": "",
    "rule": "",
    "aceEffect": "",
    "cardNumber": "CS1-18",
    "author": "",
    "artist": "",
    "imageOptions": {
      "background_url": "-5",
      "foreground_url": "-6",
      "x_pos": 0,
      "y_pos": 0,
      "x_scale": 95,
      "y_scale": 95,
      "ess_x_pos": 37,
      "ess_y_pos": 10,
      "ess_x_end": 74,
      "ess_y_end": 50,
      "fontSize": 90.5,
      "foregroundOnTop": false,
      "cardFrame": true,
      "effectBox": false,
      "addFoil": 0,
      "goldText": false,
      "aceFrame": true,
      "coloredFrame": false,
      "outline": true,
      "skipDraw": false,
      "lineSpacing": 10,
      "baselineOffset": 0,
      "specialOffset": 0,
      "bubbleRadius": 0,
      "altFontDelta": 0
    },
    "block": ""
  }`;


const test_case_1 = ` {
    "name": {  "english": "Test Monster 1"  },
    "color": "Yellow/Red",
    "cardType": "Monster",
    "cardLv": "Lv.4",
    "dp": "-",
    "evolveCondition": [
      {
        "level": "3",
        "cost": "3",
        "color": "Yellow"
      },
      {
        "level": "3",
        "cost": "3",
        "color": "White"
      },
      {
        "level": "Tamer",
        "cost": "3",
        "color": "Yellow"
      },
      {
        "level": "Tamer",
        "cost": "3",
        "color": "White"
      }
    ],
    "effect": "-",
    "playCost": "-",
    "form": "In-Training",
    "attribute": "Data",
    "type": "Sword",
    "DP": 7000,
    "rarity": "C",
    "block": "03",
    "evolveEffect": "[Twice Per Turn] This text should be white with a black border. The Evo color bubble should be solid black.",
    "cardNumber": "T-81",
    "imageOptions":{
      "background_url": "", "foreground_url": "", "x_pos": 0, "y_pos": 0, "x_scale": 95, "y_scale": 95,
      "ess_x_pos": 40, "ess_y_pos": 40, "ess_x_end": 50, "ess_y_end": 50,
      "fontSize": 90.5, "lineSpacing": 10, "baselineOffset": 0, "specialOffset": 0, "bubbleRadius": 0, "altFontDelta": 0, 
            "foregroundOnTop": false,
            "cardFrame": true,
            "effectBox": false,
            "addFoil": 0,
            "goldText": false,
            "aceFrame": true,
            "coloredFrame": false,
            "outline": true,
            "skipDraw": false

    }
}`;


const starter_text = starter_text_empty;
let all_text = "[" + [starter_text_0, starter_text_1_backup,
  starter_text_1a, starter_text_1b, starter_text_1c,
  starter_text_2, starter_text_3, starter_text_4, 
  starter_text_empty, test_case_1, ].join(",") + "]";

// deprecated from our old "share" functionality, that put the entire JSON blob into the URL compressed+encoded 
const decodeAndDecompress = (encodedString) => {
  try {
    const decoded = Base64.toUint8Array(encodedString);
    const decompressed = pako.inflate(decoded, { to: 'string' });
    return decompressed;
  } catch {
    return "";
  }
};


const drawBorder = (base_ctx, colors) => {
  const left = 180;
  const right = 2800;
  const top = 160;
  const bottom = 2940;
  const notch = 50;
  const dual = true;
  const notchWidth = dual ? 420  : 270;
  const center = (left + right) / 2;
  const cornerCut = 50;

//  const evoBubble = false;
  const cost_x = 380;
  const cost_y = 360;
  const cost_radius = 250; // 220 works

  const dp = true;
  const dp_angle = 15 / 28;
  const dp_depth = 240;
  const dp_width = 720;

  let i;
  for (i = 0; i < colors.length; i++) {
    const buffer = document.createElement('canvas');
    buffer.width = 2977;
    buffer.height = 4158 - 17;
    const ctx = buffer.getContext('2d');

    const lineWidth = 20;
    ctx.lineWidth = lineWidth;
    const fillColor = cardColor(colors[i]); 


    ctx.strokeStyle = fillColor; 
    ctx.moveTo(left, bottom);
    
    ctx.lineTo(left, top + cornerCut);
    ctx.lineTo(left + cornerCut, top);
    ctx.lineTo(center - notchWidth, top);
    ctx.lineTo(center - notchWidth + notch, top + notch);
    ctx.lineTo(center + notchWidth - notch, top + notch);
    ctx.lineTo(center + notchWidth, top);
    // done with notch
    if (dp) {
      ctx.lineTo(right - dp_width, top);
      ctx.lineTo(right - dp_width + dp_angle * dp_depth, top + dp_depth);
      ctx.lineTo(right - cornerCut, top + dp_depth);
      ctx.lineTo(right, top + dp_depth + cornerCut);
    } else {
      ctx.lineTo(right - cornerCut, top);
      ctx.lineTo(right, top + cornerCut);
      
    }
    ctx.lineTo(right, bottom);

    ctx.stroke();
    const p = Math.PI;

    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.arc(cost_x, cost_y, cost_radius - lineWidth/2 , 0, Math.PI * 2);
    ctx.fill(); // This "cuts" the line at the circle's border
    // keep wiping out extra stuff in the upper left
    ctx.beginPath();
    // west to north
    ctx.arc(cost_x, cost_y, cost_radius + lineWidth , p , p * 3/2);
    ctx.fill(); // This "cuts" the line at the circle's border
  

    ctx.globalCompositeOperation = 'source-over';

   // ctx.strokeStyle = "black";
    // draw circle
    ctx.beginPath();
    ctx.arc(cost_x, cost_y, cost_radius, - p * .29 , p * .79);
    ctx.stroke(); // This "cuts" the line at the circle's border

    ctx.globalCompositeOperation = 'destination-out';
 
    // we could save some compute by only handling the circle on the first color
    scaleZoneStart(base_ctx, i, colors.length);
    base_ctx.drawImage(buffer, 0, 0);
    scaleZoneEnd(base_ctx);
  }

}

const cardColor = (wordColor) => {
  wordColor = wordColor.toLowerCase();
  if (wordColor === 'purple') return '#6053A0';
  if (wordColor === 'green') return '#459462';  
  if (wordColor === 'red') return '#D22E37';
  if (wordColor === 'blue') return '#4B90CC';
  if (wordColor === 'yellow') return '#F3E150';
  if (wordColor === 'black') return '#201616';
  if (wordColor === 'white') return '#ffffff'; // white is white, alright.
  
  return wordColor;

}

// draws the nameBox and maybe decorates it
const nameBoxShell = (ctx, _y, colors1, colors2) => {
        let cornerCut = 50;
        let x = 167;
        const width = 2650 // 2625;
        let height = 310; // more like "depth"
        const levelWidth = 430;
  
        let traitBackground = '#000000';
        const traitHeight =  cornerCut * 1.5; 

        ctx.strokeStyle = '#FF000080';
        ctx.lineWidth = 10;

        const innerGap = 12;
        const dualNameHeight = 172;

        let i;
        let y;
        for (i = 0; i < colors1.length; i++) {
          const fillColor1 =  cardColor(colors1[i]); 
          y = _y;
          scaleZoneStart(ctx, i, colors1.length);
          // overall name box
          ctx.beginPath();
          ctx.moveTo(x + cornerCut, y);
          ctx.lineTo(x + width - cornerCut, y);
          ctx.lineTo(x + width, y + cornerCut);
          ctx.lineTo(x + width, y + height - cornerCut);
          ctx.lineTo(x + width - cornerCut, y + height);
          ctx.lineTo(x + cornerCut, y + height);
          ctx.lineTo(x, y + height - cornerCut);
          ctx.lineTo(x, y + cornerCut);
          ctx.closePath();

          ctx.fillStyle = fillColor1;
          ctx.shadowColor = fillColor1 + "80"; 
          ctx.fill();
    
          // black portion
          ctx.beginPath();
          ctx.moveTo(x + cornerCut / 2,             y + cornerCut / 2);
          // line along top of "Lv" box
          ctx.lineTo(x + levelWidth - cornerCut / 2, y + cornerCut / 2);
          // diagonal:
          ctx.lineTo(x + levelWidth, y + cornerCut);  
          ctx.lineTo(x + levelWidth, y + height - traitHeight);
          ctx.lineTo(x + levelWidth,                 y + height - traitHeight);
          ctx.lineTo(x + width, y + height - traitHeight);

          // lines here are the same as for the box
          ctx.lineTo(x + width, y + height - cornerCut);
          ctx.lineTo(x + width - cornerCut, y + height);
          ctx.lineTo(x + cornerCut, y + height);
          ctx.lineTo(x, y + height - cornerCut);
          ctx.lineTo(x, y + cornerCut);
          ctx.closePath();
          if (colors1[0] === "black") 
            traitBackground = "#ffffff";
          ctx.fillStyle = traitBackground;
          ctx.shadowColor = traitBackground + "80"; // 50% transparent
          ctx.fill();
        
          scaleZoneEnd(ctx);
        }
        // NAME BOX


        const gap = 37;

        y = y + height + gap;

        for (i = 0; i < colors2.length; i++) {
          const fillColor2 = cardColor(colors2[i]); 
          scaleZoneStart(ctx, i, colors2.length);

          // DUAL BOX. 
          cornerCut = cornerCut * .75;
          height = 172 + 12 + 558; // name part, gap, option part
          // this height should be leaving us lower

          ctx.beginPath();
          ctx.moveTo(x + cornerCut, y);
          // across the top
          ctx.lineTo(x + width - cornerCut, y); // common, 

          ctx.lineTo(x + width, y + cornerCut); // upper right
          ctx.lineTo(x + width, y + dualNameHeight);
          ctx.lineTo(x,         y + dualNameHeight);
          ctx.closePath();

          ctx.fillStyle = fillColor2;
          ctx.shadowColor = fillColor2 + "80"; 
          ctx.fill();

          ctx.beginPath();
          ctx.lineTo(x, y + dualNameHeight + innerGap);
          ctx.lineTo(x + width, y + dualNameHeight + innerGap);
          
          ctx.lineTo(x + width, y + height - cornerCut);
          ctx.lineTo(x + width - cornerCut, y + height); 
          ctx.lineTo(x + cornerCut, y + height);
          ctx.lineTo(x, y + height - cornerCut);


          ctx.lineTo(x, y + cornerCut);
          ctx.closePath();

          ctx.fillStyle = fillColor2;
          ctx.shadowColor = fillColor2 + "80"; 
          ctx.fill();
          scaleZoneEnd(ctx);
        }
        // color box for dual
        const colorWidth = 331;

        ctx.beginPath();
        ctx.moveTo(x + width - colorWidth, y);
        ctx.lineTo(x + width - cornerCut, y); // common
        ctx.lineTo(x + width, y + cornerCut); // end common
        ctx.lineTo(x + width, y + dualNameHeight);
        ctx.lineTo(x + width - colorWidth, y + dualNameHeight);
        ctx.closePath();
        
        ctx.fillStyle =   '#101010';
        ctx.shadowColor = '#10101080'; 
        ctx.fill();

        const barSpacing = 42;
        const first = x + width - colorWidth + barSpacing * .65;
        const top = y  + 12; // fudge
        for (let i = 0; i < 7; i++) {
          const left = first + i * barSpacing; // left
          ctx.beginPath();
          const bw = i === 6 ? 35 : 30;
          ctx.moveTo(left, top);
         if (i === 6) { 
            ctx.lineTo(left + bw, top + bw);
          } else {
            ctx.lineTo(left + bw, top);
          }
          ctx.lineTo(left + bw, top + 140);
          ctx.lineTo(left, top + 140);
          ctx.closePath();

          const rainbow = ['red', 'blue', 'yellow', 'green', 'black', 'purple', 'white', 'all'];

          // fill color
          if (colors2.includes(rainbow[i])) {
            ctx.fillStyle = cardColor(rainbow[i]);
          } else {
            ctx.fillStyle = '#bbb';
          }
          ctx.fill();
          ctx.strokeStyle = '#888';
          ctx.lineWidth = 6;
          ctx.stroke();
        }

        // use box
        const useWidth = levelWidth * .80;
        const path = new Path2D();

        ctx.beginPath();
        path.moveTo(x + cornerCut, y);
        path.lineTo(x + useWidth, y); 
        path.lineTo(x + useWidth, y + dualNameHeight - 10); 
        path.lineTo(x, y + dualNameHeight - 10); 
        path.lineTo(x, y + cornerCut); 
        path.closePath();
        
        ctx.fillStyle = "#D3D3D3"; 
        ctx.fill(path);

        // shadow in use box
        ctx.save();
        for (let i = 15; i >= 0; i -= 2) {
          ctx.clip(path);             
          const g = i * 10 + 50;
          ctx.strokeStyle = "rgba(" + g + "," + g + "," + g + ", 0.20)";  // Dark grey for the edge
          ctx.lineWidth = i * 4;
          ctx.shadowColor = "rgb(" + g + "," + g + "," + g + ")"; 
          ctx.stroke(path);         
        }
        ctx.restore();

        // this doesn't fit snugly, and the right color can peek out when the left color is hidden
        ctx.drawImage(arts_box, 
                x - cornerCut * 1.39, y + height - cornerCut * 9.95, // x, y
                width + cornerCut * 4.54, cornerCut * 12.5 // width, height
        );

        // duping name code, this should not be in here. we already handle the cost elsewhere.
        ctx.font = "100px MyriadProBold";

        ctx.fillStyle = 'black';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.fillText("Use", x + 50, y + 110);

        ctx.fillStyle = "black";
        drawRoundedRect(ctx, x + 240, y, 200, dualNameHeight, 50);
        ctx.strokeStyle = "grey";
        drawRoundedRect(ctx, x + 240, y, 200, dualNameHeight, 50, true);

        // line across dual box, this is a hack for now
     /*
        ctx.beginPath();
        ctx.moveTo(x, y + dualNameHeight - innerGap / 2);
        ctx.lineTo(x + width, y + dualNameHeight - innerGap / 2);

        ctx.strokeStyle = '#000';
        ctx.lineWidth = innerGap;
        ctx.shadowColor = '#0008';
        ctx.stroke();*/

}


function scaleZoneStart(ctx, _i, _len) {
  let width = 2977;
  let height = 4158 - 17;
  let i_width = width / _len;
  ctx.save(); // Save the current state 
  ctx.beginPath();
  //  console.log(405, "clipping to ", i_width * _i, 0, i_width * (_i + 1), height);
  ctx.rect(i_width * _i, 0, i_width * (_i + 1), height);
  ctx.clip();
}
function scaleZoneEnd(ctx) {
  ctx.restore();
}

// show i of len piece, scaled by scale, start at x,y
function scalePartialImage(ctx, img, _i, _len, scale, start_x, start_y, crop_top = 0, y_scale = 1, x_scale = 1) {

  let len = 1;
  let i = 0;

  // stupid to hardcode tihis
  let width = 2977;
  let height = 4158 - 17;
  let i_width = width / _len;

  if (!img) return;

  ctx.save(); // Save the current state 
  ctx.beginPath();
  //  console.log(405, "clipping to ", i_width * _i, 0, i_width * (_i + 1), height);
  ctx.rect(i_width * _i, 0, i_width * (_i + 1), height);
  ctx.clip();

  i -= 0.0
  let y = scale; let x = y * (img.width / img.height);
  // y = y / y_scale;
  x = x * x_scale;
  let fw = x / len; // smaller frame length here
  let ww = img.width / len;
  let top = 0; let bottom = 0;
  if (crop_top > 0) top = crop_top;
  if (crop_top < 0) bottom = crop_top;

  try {
    ctx.drawImage(img,
      i * ww, top, // crop x,y
      ww, img.height + bottom, // crop w,h
      start_x + i * fw, start_y, // place x,y
      (x / len), y * y_scale// place w,h
    );
  } catch (e) {
    console.log(426, "couldn't draw partial " + _i);
  }

  ctx.restore(); // Restore the previous state
}

function circleGlow(ctx, cx, cy, radius = 170) {
 // return;
      const gradient = ctx.createRadialGradient(
        cx, cy, 0,
        cx, cy, radius
      );

      gradient.addColorStop(0,   "rgba(255, 255, 255, 0.35)");
      gradient.addColorStop(0.5,   "rgba(255, 255, 255, 0.24)");
      gradient.addColorStop(0.8, "rgba(255,255,255,0.1)");
      gradient.addColorStop(0.9,   "rgba(255,255,255,0)");

      ctx.globalCompositeOperation = "lighter";
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalCompositeOperation = "source-over";



}

function writeDP(ctx, _dp, args) {

  let { x, y, size, bigsize, stroke, color } = args;
  //  let [x, y, size, stroke, color] = args[x, y,x = 2540, y = 410, size = 175, stroke = "white", color = "black") {

  if (gold_text) { 
    color = gold_gradient;
    stroke = 'black';
  }
  ctx.fillStyle = color;
  ctx.textAlign = 'right';
  ctx.textBaseline = 'bottom';


  _dp = parseInt(_dp);
  let dp_k, dp_m;
  if (isNaN(_dp)) {
  } else {
    dp_k = parseInt(_dp / 1000);
    if (dp_k === 0) dp_k = "";
    dp_m = (_dp % 1000).toString().padStart(3, '0');
    if (_dp === 0) {
      dp_k = "0";
      dp_m = "";
    }
  }
  let dp_x = x - 5;
  let neue_boost = neue ? 0 : 0;


  if (!neue) {
    bigsize *= 1.03;
    size *= 1.03;
  }
  ctx.font = `bold ${bigsize}px ${numberFont}`;

  while (dp_k > 0 || dp_k === "0") {
    // right-to-left for dp_k
    let letterSpacing = -(bigsize/13.8);// <-- do relative to small size
    let dp_char = dp_k % 10;
    ctx.lineWidth = 20;
    ctx.strokeStyle = stroke;
    if (stroke) ctx.strokeText(dp_char, dp_x, y - 0.5 * neue_boost);
    ctx.fillText(dp_char, dp_x, y - 0.5 * neue_boost);
    dp_x -= (ctx.measureText(dp_char).width + letterSpacing);
    dp_k = Math.floor(dp_k / 10);
  }

  ctx.font = `bold ${size}px ${numberFont}`;

  ctx.textAlign = 'left';
  ctx.textBaseline = 'bottom';
  dp_x = x + 10; // size / 15;
  // little num
  let y_offset = (bigsize / 12);
  if (dp_m) {
    for (let dp_char of dp_m) {
      let letterSpacing = size / 16.5;
      ctx.lineWidth = 15;
      ctx.strokeStyle = stroke;
      if (stroke) ctx.strokeText(dp_char, dp_x, y - y_offset + neue_boost);
      ctx.fillText(dp_char, dp_x, y - y_offset + neue_boost);
      dp_x += (ctx.measureText(dp_char).width + letterSpacing);
      // left-to-right for dp_m
    }
  }
}

if (3 > 4) digitSettings();
// returns neue_offset; side effect to set font
function digitSettings(ctx, number, size) {
  switch (number) {
    case 0:
    case 6:
    case 9:
      console.log(`doing ${size} helvetica for ${number}`);
      ctx.font = `bold ${size} Helvetica`; return 0;
    default:
      console.log(`doing ${size} AyarKasone for ${number}`);
      ctx.font = `bold ${size * 10} 'Courier'`; return 25;
  }
}

function CustomCreator() {
  /* eslint-disable react-hooks/exhaustive-deps */

  // took out dupe refresh-token code

  useEffect(() => {
    console.error("FIRST TIME");
    const params = new URLSearchParams(window.location.search);
    let ref = params.get("ref");
    let vid = params.get("v");
    if (ref) myRestoreState(ref, vid);
    // first time init
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  const myRestoreState = async (ref, id) => {
    try {
      let cardState = await restoreState(ref, id);
      console.log(320, cardState);
      if (!cardState) return;
      let jsonText = "";
      let jsonObject = undefined;
      if ("jsonText" in cardState) {
        jsonText = cardState.jsonText;
        jsonObject = JSON.parse(jsonText);
        if (!Array.isArray(jsonObject)) {
          jsonObject = [jsonObject];
        }
      }
      console.log(415, jsonText, jsonObject);

      jsonObject[0].imageOptions = initObject(jsonObject[0].imageOptions, initImageOptions);

      console.log(417, jsonText, jsonObject);

      // these are very old settings, we're trying to reload them in nicely, but
      // tests cases are lacking
      if ("fontSize" in cardState) {
        jsonObject[0].imageOptions.fontSize = cardState.fontSize;
      }
      // legacy options that weren't in JSON blob are in it now
      for (let obj in ["cardFrame", "effectBox", "baselineOffset", "specialOffset",
        "lineSpacing"]) {
        if (obj in cardState) jsonObject[0].imageOptions[obj] = cardState[obj];
      }
      jsonText = JSON.stringify(jsonObject, null, 2);
      updateJson(jsonText); // save state with full array

      // use first object in array
      jsonObject = jsonObject[0];
      loadNetImages(jsonObject.imageOptions);
    } catch (e) {
      console.error("restore error: " + e);
    }
  };

  // given imageOptions block, loads net images if not what we have now
  const loadNetImages = async (imageOptions) => {
    let id;
    let img_args = [];
    
    let bgid = backImg && backImg.id;
    id = imageOptions.background_url;

    let nid = Number(id);

    if (bgid === id) {
      // nothing
    } else if ((id)) {
      if (nid < 0) {
        let img = new Image();
        img.src = img_map[nid];
        setBackImg(img);
        img.id = nid;
      } else if (Number(id) !== Number(bgid))
        img_args.push("foreground=" + imageOptions.foreground_url);
    } else {
      if (backImg && backImg.src
        && !backImg.src.includes("placeholder")) {
        console.error(795, backImg.id);
        const img = new Image();
        img.src = placeholder;
        img.onload = () => {
          setBackImg(img);
        };
      }
    }

    let fgid = foreImg && foreImg.id;
    console.log(825, fgid);// , imageOptions);
    id = imageOptions.foreground_url;
    nid = Number(id);
    if (fgid === id) {
      // nothing, stop re-render loop
    } else if ((id)) {
      if (nid < 0) {
        let img = new Image();
        img.src = img_map[nid];
        setForeImg(img);
        img.id = nid;
      } else if (Number(id) !== Number(fgid))
        img_args.push("foreground=" + imageOptions.foreground_url);
    } else {
      if (foreImg)
        setForeImg(null);
    }
    console.log(834, img_args);
    if (img_args.length === 0) return;

    try {
      const response = await axios.get(`/api/image/get-url-by-id?${img_args.join("&")}`);
      console.debug("Fetched URLs:", response.data);
      response.data.forEach((data) => {
        let img = new Image();
        img.crossOrigin = "anonymous";
        img.src = data.signedUrl;
        img.onload = () => {
          img.id = data.url; // very important to set this
          if (data.type === "background") {
            setBackImg(img);
          } else {
            setForeImg(img);
          }
        };
      });
    } catch (e) {
      console.error("netimageerror", e);
    }

  }

  const params = new URLSearchParams(window.location.search);
  let share = params.get("share");
  let ref = params.get("ref");
  let start = share ? decodeAndDecompress(share) : "";
  start ||= starter_text;
  const canvasRef = useRef(null);
  const canvasRefs = useRef([null]);
  const miniTracker = useRef(null);
  const [backImg, setBackImg] = useState(null);
  const [foreImg, setForeImg] = useState(null);
  const [doDraw, setDoDraw] = useState(true);

  const [newRedraw, setNewRedraw] = useState(0);
  const pauseDraw = useRef(-1);
  // 0: no pause, 1: we're doing an update, 2: we're doing 
  // an update and will need to do at least one more 
  // at the end, if 1, set to 0. if 2, set to 0 but do draw

  const [zoom, setZoom] = useState(100);
  const [jsonText, setJsonText] = useState([start]);
  const [currentIndex, setCurrentIndex] = useState(0); // for undo
  const [cardIndex, setCardIndex] = useState(0); // for multiple cards 


  /*
    const [isSelecting, setIsSelecting] = useState(false);
  
    const [startX, setStartX] = useState(0);
    const [startY, setStartY] = useState(0);
    const [endX, setEndX] = useState(0);
    const [endY, setEndY] = useState(0);
  */
  const [selectedOption, setSelectedOption] = useState('AUTO'); // radio buttons 

  useEffect(() => {
    const img = new Image();
    img.src = placeholder;
    img.onload = () => {
      setBackImg(img);
    };
  }, []);

  /*  useEffect(() => {
      const img = new Image();
      img.src = white;
      img.onload = () => {
        setForeImg(img);
      };
    }, []);
    */

  const initImageOptions = useMemo(() => {
    return {
      background_url: "",
      foreground_url: "",
      x_pos: 0, y_pos: 0, x_scale: 95, y_scale: 95,
      ess_x_pos: 40, ess_y_pos: 40, ess_x_end: 50, ess_y_end: 50,
      fontSize: 90.5,
      lineSpacing: 10,
      baselineOffset: 0,
      specialOffset: 0,
      bubbleRadius: 0,
      altFontDelta: 0,
      foregroundOnTop: false,
      cardFrame: true,
      effectBox: false,
      addFoil: 0,
      goldText: false,
      aceFrame: true,
      coloredFrame: false,
      outline: true,
      skipDraw: false,

    };
  }, []);

  let imageOptions = "";
  try {
    let json = JSON.parse(jsonText);
    imageOptions = json.imageOptions;
  } catch { }
  imageOptions = initObject(imageOptions, initImageOptions);


  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  let _canvas = canvasRef.current;
  if (_canvas) {
    let correct = 1714;
    let _ctx = _canvas.getContext("2d");
    _ctx.font = `275px 'HelveticaNeue-CondensedBold', 'Helvetica Neue Condensed Bold', 'Helvetica Neue', 'Helvetica Neue Lt Pro'`;
    let fontwidth = Math.round(_ctx.measureText("AAAaaa423434i").width);
    neue = (fontwidth === correct);
   // neue = true;
    console.debug("h boolean", neue, "fontwidth", fontwidth, "correct", correct);
    _ctx.font = `275px 'HelveticaNeue-CondensedBold'`;
    console.debug("hv cb", Math.round(_ctx.measureText("AAAaaa423434i").width));
    _ctx.font = `275px 'Helvetica Neue Condensed Bold'`;
    console.debug("h v c b", Math.round(_ctx.measureText("AAAaaa423434i").width));
    _ctx.font = `275px 'Helvetica Neue'`;
    console.debug("hn", Math.round(_ctx.measureText("AAAaaa423434i").width));
    _ctx.font = `bold 275px 'Helvetica Neue'`;
    console.debug("bold hn", Math.round(_ctx.measureText("AAAaaa423434i").width));
  }

  const customs = [
    custom_1,
    custom_2, custom_3, custom_4,
    custom_5, custom_6,
    custom_7
  ];
  const custom_starter = `# This is a sample custom text taken from the customs channel.
# Start typing to watch it update.
# (Undo and updates to the other forms won't propagate here.)

` + customs[Math.floor(Math.random() * (customs.length - 0))];
  // if a shared card, default to the fields list
  const [showJson, setShowJson] = useState(ref ? 0 : 2);
  const [formData, setFormData] = useState({}); // redundant
  // const [shareURL, setShareURL] = useState("");
  const [freeform, setFreeForm] = useState(custom_starter);


  const flattenJson = (obj, parentKey = '', result = {}) => {
    for (let key in obj) {
      const propName = parentKey ? `${parentKey}.${key}` : key;
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        flattenJson(obj[key], propName, result);
      } else if (Array.isArray(obj[key])) {
        for (let element in obj[key]) {
          flattenJson(obj[key][element], `${propName}.${element}`, result);
          //          result[`${propName}.${element}`] = JSON.stringify(obj[key][element]); // Convert arrays to string for display
        }
        //        result[propName] = JSON.stringify(obj[key]); // Convert arrays to string for display
      } else {
        result[propName] = obj[key];
      }
    }
    return result;
  };


  // takes the array of cards, as text
  const jsonToFields = (text) => {
    let imageOptions = "";
    let json;
    try {
      const jsonArray = JSON.parse(text);

      for (let i = canvasRefs.current.length; i < jsonArray.length; i++) {
        canvasRefs.current[i] = null;
      }
      canvasRefs.current.length = jsonArray.length;
      json = jsonArray[cardIndex];
      imageOptions = json.imageOptions;
    } catch (e) {
      console.error("invalid json parse", e);
      console.log("<<" + text + ">>");
      return; // no json to parse, don't populate fields...
    }

    imageOptions = initObject(imageOptions, initImageOptions);
    json.imageOptions = { ...imageOptions };
    try {
      flattenedJson = flattenJson(json);
    } catch (e) {
      jsonerror = e;
      console.error("json error", e);
      return;
    }
    Object.entries(flattenedJson).forEach(([key, value]) => {
      formData[key] = value;
    })
    loadNetImages(imageOptions);


  }

function drawTextWithSpacing(ctx, text, x, y, spacing, fillSize) {

 let nextspace = 0;

 if (text === "") return;
 let text_length = text.length;
 let totalWidth = ctx.measureText(text).width + spacing * (text_length - 1);
 if (fillSize) {
    if (text_length === 1) text_length = 2;
    spacing = (fillSize - ctx.measureText(text).width) / (text_length - 1);
    totalWidth = fillSize;
 }
 let currentX = x - totalWidth / 2;
 for (let char of text) {
   let offset = 0;
   const charWidth = ctx.measureText(char).width;
   // characters too far right
   if (char === "I") offset -= charWidth * .75;
   if (char === "-") offset -= charWidth * .25;
   if (char === "/") offset -= charWidth * .25;
   if (char === "⁄") offset -= charWidth * 1.35;
  // characters too far left
   if (char === "M") offset += charWidth * .15;
   if (char === "W") offset += charWidth * .10;
   ctx.strokeText(char, currentX + offset, y);
   ctx.fillText(char, currentX + offset, y);
   currentX += charWidth + spacing + nextspace;
 }
}

  function popEvoCond(json_t) {

    const json_all = JSON.parse(json_t);
    console.log(166.0, json_all);
    const json = json_all[cardIndex];
    console.log(166.1, json);
    console.log(166.2, json.evolveCondition);
    json.evolveCondition.pop();
    console.log(166.3, json.evolveCondition);
    updateJson(JSON.stringify(json_all, null, 2));
  }

  function pushEvoCond(json_t) {
    const json_all = JSON.parse(json_t);
    const json = json_all[cardIndex];
    json.evolveCondition.push({ color: "", cost: "", level: "" });
    updateJson(JSON.stringify(json_all, null, 2));
  }


  let jsonerror = "none";

  // any missing fields are added
  const addAllFields = (jsonArray) => {
    console.log(1565, 2);
    if (!Array.isArray(jsonArray)) {
      jsonArray = [jsonArray];
    }
    for (let json of jsonArray) {
      //      let json = jsonArray[i];
      if (!("name" in json)) {
        json.name = {};
      }
     
      /*
      // IF we are in DUAL mode, insert "optionCardColourRequirement" after "color"
      // we need to lose the british spelling here
      if (!("optionCardColorRequirement" in json)) {
        console.log(1565, type);
        console.log(1565, json);
        if (type === "DUAL") {
          let json_temp = Object.entries(json)
          let index = json_temp.findIndex( ([key]) => key  === "color")
          console.log(1565, 444, index);
          console.log(1565, "color", json["color"]);
          let color = json["color"] || "blue";
          json_temp.splice(index+1, 0, ["optionCardColorRequirement", color] )
          json = Object.fromEntries(json_temp);
          console.log(1565, 9,  JSON.stringify(json) );
          console.log(1565,json_temp);

          console.log(1565, json);
        }
      }*/

      for (let field of ["color", "cardType", "playCost",
        "dp", "cardLv", "form", "attribute", "type", "rarity",
        "block",
        "linkDP", "linkRequirement", "linkEffect",
        "specialEvolve", "effect", "evolveEffect", "securityEffect",
        "aceEffect",
        "rule", "digiXros", "assembly", "burstEvolve", "cardNumber",
        "author", "artist"]) {
        if (!(field in json)) {
          console.log("Missing field added " + field);
          json[field] = "";
        }
      }
      if (!("evolveCondition" in json)) {
        json.evolveCondition = [];
      }
      let imageOptions = json.imageOptions;
      imageOptions = initObject(imageOptions, initImageOptions);
      json.imageOptions = imageOptions;
      // shouldn't the default for imageOptions handle the below??

      // falses
      for (let field of ["foregroundOnTop", "effectBox", "skipDraw", "coloredFrame", "goldText"]) {
        if (!(field in json.imageOptions)) {
          console.log("Missing field added 1 " + field);
          json.imageOptions[field] = false;
        }
      }
      // trues
      for (let field of ["cardFrame", "aceFrame", "outline"]) {
        if (!(field in json.imageOptions)) {
          console.log("Missing field added" + field);
          json.imageOptions[field] = true;
        }
      }
      // zeros
      for (let field of ["bubbleRadius", "altFontDelta", "addFoil"]) {
        if (!(field in json.imageOptions)) {
          console.log("Missing field added" + field);
          json.imageOptions[field] = 0;
        }
      }
      // if "addfoil" is boolean, change it to numeric
      if (typeof (json.imageOptions.addFoil) === "boolean") {
         json.imageOptions.addFoil += 0;
      }


      if (!("english" in json.name)) {
        json.name.english = "Mon";
      }
      if (json.evolveCondition.length === 0) {
        json.evolveCondition.push({ color: "", cost: "", level: "" });
      }
      imageOptions = initObject(imageOptions, initImageOptions);
      json.imageOptions = imageOptions;
   //   console.log(1565, "setting " + i);
      console.log(1565, 55, JSON.stringify(jsonArray))
  //    jsonArray[i] = json; // update in place          
      console.log(1565, 66, JSON.stringify(jsonArray));

    }
    // does accepting this return do anything?
    return jsonArray;
  }

  const updateJson = (text) => {

    console.log(1565, "update json");
    let json;
    try {
      json = JSON.parse(text);
      imageOptions = json.imageOptions;
    } catch (e) {
      console.error("incomplete json:", e);
    }
    // only fix things if we've got a valid json
    if (json) {
      if (!Array.isArray(json)) {
        json = [json];
      }
      for (let subImage of json) {
        subImage = addAllFields(subImage);
      }
      text = JSON.stringify(json, null, 2);
      console.log(918, json, text);
      jsonToFields(text);
    }

    const newHistory = jsonText.slice(0, currentIndex + 1);
    setJsonText([...newHistory, text]);
    setCurrentIndex(newHistory.length);
  }


  function handleFreeformChange(form){
    console.log(302, form.free.value);
    let input = form.free.value;
    if (input.length < 5) return;
    console.log(304, input);
    let jsonTxt = enterPlainText(input.split("\n"));
    console.log(307, jsonTxt);
    updateJson(jsonTxt);
    jsonToFields(jsonTxt);

  }

  function handleTextareaChange(value) {
    // update the form data
    let jsonTxt = value;
    updateJson(jsonTxt);
    jsonToFields(jsonTxt);
    /*  try {
        parsedJson = JSON.parse(event.target.value);
        flattenedJson = flattenJson(parsedJson);
        console.log(flattenedJson);
      } catch (e) {
        jsonerror = e;
        console.error("json error");
        return;
      }
      Object.entries(flattenedJson).map(([key, value]) => {
        formData[key] = value;
      }
      ) */
  }

  const updateZoom = (e) => {
    let z = e.target.value;
    // moved validation logic out of here
    setZoom(z);
  }

  const handleInputChange = (key, value, type, checked) => {
    console.log(918, key);
    console.log(919, value);
    console.log(920, type);
    if (type === "boolean") { value = checked; }
    console.log(921, value);
    console.log("form data", formData);
    const newFormData = { ...formData, [key]: value };
    setFormData(newFormData);

    // Update the JSON text based on form data
    try {
      const updatedJson = JSON.parse(jsonText[currentIndex]);
      const keys = key.split('.');
      let current = updatedJson[cardIndex];
      keys.forEach((k, index) => {
        if (index === keys.length - 1) {
          current[k] = value;
        } else {
          current = current[k];
        }
      });
      updateJson(JSON.stringify(updatedJson, null, 2));
    } catch {
      // json error
    }
  };

  let parsedJson, flattenedJson;
  try {
    parsedJson = JSON.parse(jsonText[currentIndex]);
    parsedJson = parsedJson[cardIndex];
    flattenedJson = flattenJson(parsedJson);
  } catch (e) {
    jsonerror = e.toString();
    //  console.error("json error");
  }

  //    const whitePixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/ovfdKgAAAAASUVORK5CYII=';

  const setWhite = () => {
    const img = new Image();
    img.onload = () => {
      setBackImg(img);
    };
    img.src = white;
  }
  const setTrans = () => {
    const img = new Image();
    img.onload = () => {
      setBackImg(img);
    };
    img.src = transparent;
  }

  // read from user's device
  const loadUserImage = (event, foreground) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      const id = Number(Math.round(Math.random() * 1000 * 1000));
      img.id = id;
      console.error(1000, img.id);
      img.onload = () => {
        if (foreground)
          setForeImg(img);
        else
          setBackImg(img);
      };
      const key = `imageOptions.${foreground ? "foreground_url" : "background_url"}`;
      handleInputChange(key, id, "number");
    };
    reader.readAsDataURL(file);

  };

  // read from gallery
  const handleSelectImage = (url, foreground, id) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    console.error(1170, url, id);
    if (!id) {
      id = (url.match(/\d+/) || [])[0];
    }
    img.id = id;
    img.onload = () => {
      if (foreground) {
        setForeImg(img);

      } else {
        setBackImg(img);
        img.id = id;
      }
    };
    const key = `imageOptions.${foreground ? "foreground_url" : "background_url"}`;
    handleInputChange(key, id, "number");
  };

  /*
  const loadImageFromUrl = () => {
    const img = new Image();
    img.crossOrigin = "Anonymous"; // of CORS
    img.src = imageOptions.url;
    img.onload = () => {
      setUserImg(img);
    };
  };*/

  const sample = (number) => {
    console.log("UPDATING TO " + number);
    let text = '';
    let img_src = '';
    let back_src = '';
    switch (number) {
      case 0: text = starter_text_0;; break;
      case 1: text = starter_text_1a; break;
      case 2: text = starter_text_1b; break;
      case 6: text = starter_text_1c; break;
      case 3: text = starter_text_2; break;
      case 4: text = starter_text_3; break;
      case 5: text = starter_text_1; img_src = armor_cat; back_src = field; break;
      case 7: text = starter_text_4; break;
      case -1: text = all_text; break;
      default: alert(3); return;
    }
    setCardIndex(0);
    canvasRefs.current.length = 7;
    console.log(409, "omg");
    canvasRefs.current = [null];
    setDoDraw(false);
    console.log(411, doDraw);

    setSelectedOption("AUTO");
    if (number === 5) {
      setShowJson(2);
      setFreeForm(text);
      text = enterPlainText(text.split("\n"));
      updateJson(text);
    } else {
      setFreeForm("");
      if (showJson === 2) setShowJson(0);
      updateJson(text);
    }
    //console.log("SETTING JSON TEXT", text);
    jsonToFields(text);
    //console.error(889, img_src);
    if (img_src) {

      const img = new Image();
      img.src = img_src;
      img.onload = () => {
        console.error("foreground");
        setForeImg(img);
      };
    }
    if (back_src) {
      console.error("settings back");
      const img2 = new Image();
   //   img2.id = -0; // hard-code for armor_cat, the only one that needs it, because it's example isn't json
      img2.src = back_src;
      img2.onload = () => {
        //console.log(901, img2);
        setBackImg(img2);
      }
      img2.onerror = () => {
        console.error(908, img2);
      }
    }
    console.log(433, "making true");
    setDoDraw(true);
  }


  const draw2 = (x, y) => draw(x, y, true);

  //  const draw = (canvas, ctx) => {
  //  const draw = async (x, y, clear) => {

  const draw = useCallback(async (x, y, clear) => {
    console.log(1879.1, pauseDraw.current);
    if (!backImg) return;
    if (pauseDraw.current <= 0) {
      pauseDraw.current = 1; // drawing, continue
    } else if (pauseDraw.current === 1) {
      pauseDraw.current = 2; // drawing, but do one more after we're done
      return;
    } else if (pauseDraw.current >= 2) {
      pauseDraw.current = 2; // drawing, but do one more after we're done
      return;
    }

    if (!doDraw) {
      console.error(964, "NOT DRAWING");
      return false;
    }
    console.debug(643, "START DRAW", pauseDraw.current);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    setupRoundedCorners(ctx, canvas.width, canvas.height, 15);

    console.log("===");
    if (clear) {
      console.log("clear is ", clear);
      //canvas.width = 2977;
    }
    if (document.fonts.check('bold 60px Helvetica')) {
    } else {
    }

    //await document.fonts.ready;
    // just load the page, fonts will come in soon enough
    console.log(745, neue);

    if (document.fonts.check('bold 60px Roboto')) {
      //    console.error("roboto pass2");
    } else {
      //   console.error("roboto fail2");
    }


    if (clear === true) {
      miniTracker.width = 2977;
      miniTracker.height = 4158 - 17;
      canvas.width = 2977;
      canvas.height = 4158 - 17;
      const ctx = canvas.getContext('2d');
      setupRoundedCorners(ctx, canvas.width, canvas.height, 15);
    }
    let json;
    try {
      let jsontext = jsonText[currentIndex];
      json = JSON.parse(jsontext);
      if (Array.isArray(json)) {
        let arrayIndex = Number(cardIndex);
        if (arrayIndex >= json.length) arrayIndex = json.length - 1;
        json = json[arrayIndex];
      }
    } catch (e) {
      console.log(1879.2, pauseDraw.current);

      console.log("json error", e);
      if (pauseDraw.current > 1) {
        pauseDraw.current = 0;
      } else {
        pauseDraw.current = -1;
      }
      return;
    }

    // if given an array, only draw first object
    if (Array.isArray(json)) {
      json = json[0];
    }

    let modern = 1;
    const has_cost = (json.playCost.length > 0 && (json.playCost >= 0 || json.playCost.length > 2 ));
    // TODO: make cost an array to avoid inline trinaries

    let t;
    let array = basics;
    let cardframes = [has_cost ? mon_background : mon_background_nocost];
    type = selectedOption;
    let overflow = undefined;
    const evo_effect = json.evolveEffect || json.digivolveEffect;


    let imageOptions = "";
    try {
      let json = JSON.parse(jsonText[currentIndex]);
      json = json[cardIndex];
      imageOptions = json.imageOptions;
    } catch { }
    imageOptions = initObject(imageOptions, initImageOptions);


    if (type === "DUAL") {
      // what's the best place to do this?
      let added_fields = false;


//      if (!("optionCardColourRequirement" in json)) {
        
      let json_temp = Object.entries(json);
      if (!("optionCardColourRequirement" in json)) {
        // add after 'color'
        let index = json_temp.findIndex( ([key]) => key  === "color");
        let color = json["color"] || "blue";
        json_temp.splice(index+1, 0, ["optionCardColourRequirement", color] )
        added_fields = true;
      }
      if (!("optionCardEffect" in json)) {
        // add after 'effect'
        let index = json_temp.findIndex( ([key]) => key  === "effect");
        let optionCardEffect = "-";
        json_temp.splice(index+1, 0, ["optionCardEffect", optionCardEffect] )
        added_fields = true;
      }
      if (!("dualEffect" in json)) {
        // add after 'effect'
        let index = json_temp.findIndex( ([key]) => key  === "effect");
        let dualEffect = "[Arts Digivolve]";
        json_temp.splice(index+1, 0, ["dualEffect", dualEffect] )
        added_fields = true;
      }
      
      if (added_fields) {
          json = Object.fromEntries(json_temp);
          let current = JSON.parse(jsonText[currentIndex]);          
          current[cardIndex] = json;        
          const text = JSON.stringify(current, null, 2);
          const newHistory = jsonText.slice(0, currentIndex + 1);
          setJsonText([...newHistory, text]);
          setCurrentIndex(newHistory.length);
      }
    }

    if (type === "AUTO") {
      type = "MONSTER";
      if ((json.cardLv === "Lv.6" || json.cardLv === "Lv.7") && empty(json.evolveEffect)) {
        type = "MEGA";
      }
      if (!empty(json.linkDP)) {
        type = "LINK";
      }
      if (json.aceEffect && json.aceEffect.length > 5) {
        type = "ACE";
      }
      if ((t = json.cardType)) {
        if (t.match(/option/i)) {
          type = "OPTION";
          if (!empty(evo_effect))
            type = "OPTIONINHERIT";
        }
        if (t.match(/tamer/i)) {
          type = "TAMER";
          if (!empty(evo_effect))
            type = "TAMERINHERIT";
        }
        if (t.match(/egg/i) || t.match(/tama/i)) { type = "EGG"; }      
      }
      if (!empty(json.dualEffect)) type = "DUAL";
    }
    array = (has_cost || type === "EGG") ? outlines : outlines_nocost;
    const colors = (json && json.color && json.color.toLowerCase().split("/")) || ["red"]; 
    const optionColors = (json && json.optionCardColourRequirement && json.optionCardColourRequirement.toLowerCase().split("/")) || ["black"]; 
    switch (type) {
      case "MEGA": cardframes = [has_cost ? mega_background : mega_background_nocost]; break;
      case "OPTION":
      case "OPTIONINHERIT": cardframes = [has_cost ? option_background : option_background_nocost]; break;
      case "TAMER":
      case "TAMERINHERIT":
        cardframes = [has_cost ? tamer_background : tamer_background_nocost]; break;
      // Is there any way to indicate we should use the no_cost egg background??
      case "EGG": cardframes = [has_cost ? egg_background : egg_background]; break;
      case "LINK":
      case "MONSTER": break;
      case "DUAL": 
          if (imageOptions.aceFrame) {
            if (dual_backgrounds[colors[0]]) cardframes = colors.map(c => dual_backgrounds[c] || dual_background);
          } else {
            cardframes = [dual_background];
          }
        break;
      case "ACE":
        if (imageOptions.aceFrame) {
          if (ace_backgrounds[colors[0]]) cardframes = colors.map(c => ace_backgrounds[c] || mon_background);
        }
        let match = json.aceEffect && json.aceEffect.match(/Overflow\s*.-(\d+)/i);
        if (match) {
          overflow = parseInt(match[1]);
        } else { // if no overflow set, use level as backup
          match = json.cardLv && json.cardLv.match(/\d+/);
          //console.log(528, match);
          if (match) overflow = parseInt(match) - 2;
        }
        break;
      default: alert(2);
    }

    // options don't need to load frames
    const len = (type === "OPTION" || type === "OPTIONINHERIT") ? 1 : colors.length;
    const frameImages = Array.from({ length: len }, () => new Image());
    const baseImg = backImg;

    const shellImages = [];
    const evoImages = [];
    const wedgeImages = [];
    const _evos = json.evolveCondition || json.digivolveCondition;

    const updateBigCanvas = () => {
      const source = canvasRefs.current[cardIndex];
      const target = miniTracker.current;
      if (!source || !target) return;
      const ctx1 = target.getContext('2d');
      ctx1.clearRect(0, 0, target.width, target.height);
      ctx1.drawImage(source, 0, 0, target.width, target.height);
    }


    const afterLoad = async () => {
      console.log("LOADING2");

      set_gold_text(json.imageOptions.goldText);
      const drawMon = (mon_img, height) => {
        height = 4000; // don't try this now
        console.log(986, json);
        if (!mon_img) return;
        // mon image
        //      console.log("imageOptions", imageOptions);
        let i_width = canvas.width * Number(imageOptions.x_scale) / 100;
        let i_height = canvas.height * Number(imageOptions.y_scale) / 100;
        let i_x_pct = (100 - Number(imageOptions.x_scale)) / 2 + Number(imageOptions.x_pos);
        let i_y_pct = (100 - Number(imageOptions.y_scale)) / 2 + Number(imageOptions.y_pos);
        ctx.drawImage(mon_img,
          i_x_pct * canvas.width / 100, i_y_pct * canvas.height / 100, i_width, i_height / 1);
      }


      if (document.fonts.check('bold 60px Roboto')) {
        //     console.error("roboto pass3");
      } else {
        //     console.error("roboto fail3");
      }

      await document.fonts.ready;

      if (document.fonts.check('bold 60px Roboto')) {
        //console.error("roboto pass4");
      } else {
        //  console.error("roboto fail4");
      }

      // Set the canvas dimensions



      // DRAW BACKGROUND, IF WE HAVE IT
      let background_img = backImg;
      if (background_img && background_img.src) {
        console.log(1227, "DRAWING BACKGROUND");

        /*        ctx.save();
                ctx.beginPath();
                ctx.rect(0, 0, canvas.width - 30, canvas.height);
                ctx.clip(); */
        ctx.drawImage(background_img, 0, 0, canvas.width, canvas.height);
        //        ctx.restore();
      } else {
        console.log(1227, "NOT DRAWING BACKGROUND");
      }

      let bottom_y = 3550 - 440
      if (type === "MEGA") bottom_y += 500;
      if (type === "ACE") bottom_y += 1;

      let mon_img = foreImg;
      // bottom doesn't matter for under draw
      if (!imageOptions.foregroundOnTop) drawMon(mon_img, bottom_y + 2000);
      //      let h = canvas.height;
      let len = colors.length;
      // multicolor
      //    let fw = w / len; // frame width
      let offset_x = 90, offset_y = 72;
      if (!modern) { offset_x = 0; offset_y = 0; }

      let bottom = offset_y + 2760;
      if (type === "EGG") bottom -= 640;
      if (type === "DUAL") bottom -= (640 + 142)
      if (type === "MONSTER" || type === "LINK") bottom -= 500;
      if (type === "ACE") bottom -= 480;
      if (type.startsWith("TAMER") || type.startsWith("OPTION")) bottom -= 640;

      if (imageOptions.skipDraw) {
        if (pauseDraw.current > 1) {
          pauseDraw.current = 0;
        } else {
          pauseDraw.current = -1;
        }
        return;
      }
      console.log(1323, imageOptions);
      console.log(1324, imageOptions.effectBox);

      if (imageOptions.effectBox) {
        for (let i = 0; i < len; i++) {
          /*let col = colors[i];
          if (!col) continue;
          let box = new Image();
          box.src = effectboxes[col];*/
          //          let true_bottom = 4000;
          //        let y_scale = ((true_bottom) - (bottom + 60 - baselineOffset)) / box.height;
          const box = effectFrames[i];
          console.log(1335, box);
          if (box && box.complete) {
            console.log(1051, box, box.height);
            let y_scale = effectBoxScale(box.height, imageOptions.baselineOffset);
            scalePartialImage(ctx, box, i, len, 825, offset_x + 100, bottom + 60 - imageOptions.baselineOffset, 0, y_scale);
          }
        }
      }

      if (imageOptions.cardFrame) {
        // new style background
        // we know shellimg is loaded because of pre-flight

        if (imageOptions.addFoil > 0) {

          const baseImage = shellImages[0];

          const offScreenCanvas = document.createElement('canvas');
          offScreenCanvas.width = canvas.width;
          offScreenCanvas.height = canvas.height;
          const offScreenCtx = offScreenCanvas.getContext('2d');

          // Draw base image on off-screen canvas
          offScreenCtx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);

          // Create image data for the base image
          const baseImageData = offScreenCtx.getImageData(0, 0, canvas.width, canvas.height);
          const basePixels = baseImageData.data;

          // Clear the off-screen canvas before drawing the overlay image
          offScreenCtx.clearRect(0, 0, canvas.width, canvas.height);
          const overlay = Number(imageOptions.addFoil) === 1 ? foil : gold;
          offScreenCtx.drawImage(overlay, 0, 0, canvas.width, canvas.height);

          // Create image data for the overlay image
          const overlayImageData = offScreenCtx.getImageData(0, 0, canvas.width, canvas.height); // Use canvas.width and canvas.height for consistency
          const overlayPixels = overlayImageData.data;

          for (let i = 0; i < basePixels.length; i += 4) {
            const baseAlpha = basePixels[i + 3] / 255;
            const overlayAlpha = overlayPixels[i + 3] / 255;

            // Composite alpha
            const finalAlpha = overlayAlpha + baseAlpha * (1 - overlayAlpha);

            if (finalAlpha > 0) {
              basePixels[i] = Math.round((overlayPixels[i] * overlayAlpha + basePixels[i] * baseAlpha * (1 - overlayAlpha)) / finalAlpha); // Red
              basePixels[i + 1] = Math.round((overlayPixels[i + 1] * overlayAlpha + basePixels[i + 1] * baseAlpha * (1 - overlayAlpha)) / finalAlpha); // Green
              basePixels[i + 2] = Math.round((overlayPixels[i + 2] * overlayAlpha + basePixels[i + 2] * baseAlpha * (1 - overlayAlpha)) / finalAlpha); // Blue
              // basePixels[i + 3] = Math.round(finalAlpha * 255); // Alpha
            }
          }
          offScreenCtx.putImageData(baseImageData, 0, 0);

          // Draw the composite image on the main canvas
          ctx.drawImage(baseImage, 0, 0, canvas.width * 1, canvas.height); // Draw the original base image scaled to canvas
          ctx.drawImage(offScreenCanvas, 0, 0, canvas.width, canvas.height); // Draw the composite image scaled to canvas

          // Put the modified image data back to the off-screen canvas
          offScreenCtx.putImageData(baseImageData, 0, 0);
          // Draw the composite image on the main canvas
          let ace_scale = 1; // aceFrame ? .: 0.95;
          ctx.drawImage(shellImages[0], 0, 0, canvas.width * ace_scale, canvas.height * ace_scale);
          ctx.drawImage(offScreenCanvas, 0, 0, canvas.width, canvas.height);

        } else {
          // no foil

          let shells = shellImages;
          if (imageOptions.coloredFrame && colors.length > 1) {
            console.log(1379, "drawing colored border", colors.length);
            shells = Array(colors.length).fill(shellImages[0]);
          }

          let len = shells.length;
          for (let i = 0; i < shells.length; i++) {
            // this isn't loading the very first time for each color
            // 
            const line = lines[colors[i]];
            const colored = (imageOptions.coloredFrame && line) ?
              applyGradientToFrame(shellImages[0], line) : shells[i];
            scalePartialImage(ctx, colored, i, len, 4141, 0, 0, undefined, 1.0, 1.004)
          }
        }
      }

      if (type === "DUAL") {
          drawBorder(ctx, colors);
      }


      // OUTLINE?
      let border_scale = 3950;
      if (type === "MEGA" && imageOptions.outline) {
        console.log(602, frameImages.length);
        // draw the left and right line all the way down. crop off the top 1000 pixels
        try {
          if (frameImages[0].complete)
            scalePartialImage(ctx, frameImages[0], 0, len, border_scale,
              offset_x, offset_y + 1100, 600);
          let last = len - 1;
          if (frameImages[last].complete)
            scalePartialImage(ctx, frameImages[last], last, len, border_scale, offset_x, offset_y + 1100, 600);
        } catch (e) { // couldn't sufficiently check this w/o a try/catch
          console.log(611, e);
        }
      }

      /// WRITE NAME
      let has_traits = (!empty(json.form) || !empty(json.attribute) || !empty(json.type));


      // OUTLINE
      for (let i = 0; i < len; i++) {
        let col = colors[i];
        let frame = frameImages[i];

        if (frame && imageOptions.outline) {
          let l = (type.startsWith("OPTION")) ? 1 : len; // just 1 option "outline"
          let fudge = (type === "OPTION" || !i) ? 0 : 0.04;
          fudge = 0;
          // 1.05 is fudge factor because our frames aren't all left-justified the same
          // this makes them  the same, but they might be the same wrong
          // y - 1.5 to avoid tiniest stray pixels above egg frame on upper left
          scalePartialImage(ctx, frame, i + (fudge), l, border_scale, offset_x, offset_y - 1.5,
            undefined, 1, 1.00);
        }
        // DRAW BOTTOM OF BOX?
        if (imageOptions.outline && (type === "LINK" || type === "MONSTER" || type === "MEGA" || type === "ACE")) {
          // bottom of frame
          let border = borders[col];
          if (type === "ACE") bottom_y += 20;
          scalePartialImage(ctx, border, i, len, 67.3 * border_scale / 3950,
            166, bottom_y);
          // todo: play with these numbers some more. scale is 67.2-67.5,
          // and left is 166
        }

      }
      // top mon?
      if (imageOptions.foregroundOnTop) drawMon(mon_img, bottom_y + 45);

      //// DRAW TOP TEXT
      ctx.textAlign = 'center';
      ctx.fillStyle = 'white';
      ctx.strokeStyle = 'black';
  //    ctx.font = `bold 84px Roboto`;
      ctx.font = `bold 70px Anago-Medium`;
      let cardText = json.cardType.toUpperCase();
      ctx.lineJoin = 'round'; // prevent spikes
      ctx.lineWidth = 12;
      ctx.fillStyle = 'black';
              ctx.fillStyle = '#181818';

      ctx.strokeStyle = 'white';
      if (cardText === "OPTION") {
       ctx.fillStyle = 'white';
       ctx.strokeStyle = '#2F4E6E';
      }

      if (cardText.includes("/") || cardText.includes("⁄")) {
        let words = cardText.split(/[/⁄]/);
        let x = 1515;
        drawTextWithSpacing(ctx,"⁄",1515,170,12);
        let offset = 160;
        let slashpadding = 40;        
        drawTextWithSpacing(ctx,words[0].trim(), x - offset - slashpadding, 170, 0, offset*2);
        drawTextWithSpacing(ctx,words[1].trim(), x + offset + slashpadding, 170, 0, offset*2);
     } else {      
      drawTextWithSpacing(ctx,cardText,1515,170,12)
     }

      // DRAW AUTHOR
      if (true) try {
        for (let scale = 1.20; scale >= 1.0; scale -= 0.04) {
          let width = 51 * scale; let height = 122 * scale;
          ctx.drawImage(pen_img, 2890 - width / 2,
            530 - height / 2,
            width,
            height);
        }
      } catch (e) {
        console.log(1529, e);
      }
      const here = new URL(window.location.href);
      const author = empty(json.author) ? "" : json.author;
      // if no neue, mark version number with an n
      const ver = ("v" + version + (neue?"":"n")) || "";
      const artist = (!empty(json.artist) && json.artist !== "-") ? json.artist : ver + "    " + here
      const credit = (author + "   " + artist).trim();

      ctx.font = '70px Hiragino';
      ctx.save();
      ctx.translate(2925, 560);
      ctx.rotate(-Math.PI / 2);

      ctx.textAlign = "right";

      ctx.lineWidth = 15
      ctx.strokeText(credit, -51, 0);
      ctx.fillText(credit, -51, 0);
      ctx.restore();

      // OTHER MULTICOLOR
      for (let i = 0; i < len; i++) {
        if (modern && type !== "DUAL") {
          let name_field = bottoms; // i'm so sorry this is named 'bottom'
          if (type.startsWith("OPTION") || type.startsWith("TAMER")) name_field = bottoms_plain;
          let col = colors[i];


          if (outlines[col]) {


            let y_scale = 1;
            ///// EVO BOX AT BOTTOM (OR LINK BOX)
            if (type !== "MEGA" && type !== "DUAL") {
              let img = bottom_evos[col];
              if (!empty(json.securityEffect)) {
                img = inherited_mon_security[col];
              }
              // scale = 606 specifically for bottom_evo_${color}.png
              let scale = 735;
              let height = 3550;
              if (type === "LINK" || !empty(json.linkDP)) {
                img = bottoms_plain[col];
                scale = 305;
                height = 3210;
                y_scale = 1.5;
                if (type !== "LINK") {
                  height = 3110;
                }
              } else if (type === "ACE") {
                img = undefined; //   img = bottom_aces[col];
                scale = 606;
              } else if (type === "OPTION" || type === "TAMER" || type === "EgjgjGG") {
                img = inherited_security[col];
                scale = 740;
                height = 3450;
              }
              // egg doesn't change inherited but does change scale and height 
              if (type === "EGG") {
                img = bottom_egg_evos[col];
                scale = 720;
                height = 3470;

              }

              if (type === "TAMERINHERIT" || type === "OPTIONINHERIT") {
                // tamer inherit has ESS box but raised height
                height = 3450;
              }
              if (img)
                scalePartialImage(ctx, img, i, len, scale, 164, height, undefined, y_scale);
            }

            if (type === "ACE") {
              scalePartialImage(ctx, ace_box,
                0, 1,
                326,
                94, 3525
              );
            }



            /// DRAW ESS BOX
            if (mon_img) {
              let ess_i_width = (Number(imageOptions.ess_x_end) - Number(imageOptions.ess_x_pos)) * mon_img.width / 100
              let ess_i_height = (Number(imageOptions.ess_y_end) - Number(imageOptions.ess_y_pos)) * mon_img.height / 100
              let ess_x = Number(imageOptions.ess_x_pos) * mon_img.width / 100
              let ess_y = Number(imageOptions.ess_y_pos) * mon_img.height / 100
              let ess_pos_y = 3700;
              let ess_pos_x = 240;
              let size_x = 350;
              let size_y = 350;

              if (type === "MEGA" || type === "OPTION" || type === "TAMER") ess_pos_y = 0;
              if (!empty(json.securityEffect)) ess_pos_y = -3500; // just hiding it
              if (type.endsWith("INHERIT")) ess_pos_y -= 105;
              if (type === "LINK") {
                ess_pos_y -= 310;
                ess_pos_x += 2200;
                size_y = 150;
                ctx.save();
                ctx.translate(ess_pos_x + size_x / 2, ess_pos_y + size_y / 2);
                ctx.rotate(Math.PI / 2)
                ess_pos_x = -size_x / 2
                ess_pos_y = -size_y / 2; // i've translated to where i need to be
              }
              if (type === "EGG") ess_pos_y -= 80;
              if (type === "ACE") {
                ess_pos_y += 135;
                ess_pos_x += 30;
                size_x = size_y = 250;
              }
              if (ess_pos_y) {
                ctx.drawImage(mon_img,
                  ess_x, ess_y, ess_i_width, ess_i_height,
                  ess_pos_x, ess_pos_y, size_x, size_y
                );
              }
            }
            if (type === "LINK") {
              // move this up one block?
              ctx.restore();
            }

            // LINK TEXT if needed
            if (type !== "LINK" && !empty(json.linkDP)) {

              ctx.save();
              ctx.translate(2680, 3610);
              ctx.rotate(Math.PI / 2);

              // white background
              ctx.fillStyle = "white";
              ctx.fillRect(-450, 0, 400, 150);

              ctx.font = `bold 100px 'Helvetica'`;

              ctx.fillStyle = "black";
              ctx.textAlign = "center";
              ctx.fillText("LINK", -250, 120);


              ctx.restore();

            }

            // DP LINK BOX
            if (type === "LINK" || !empty(json.linkDP)) {
              let w = linkdp.width; let h = linkdp.height;
              let s = 4.72
              let y_pos = 3210;
              let link_offset = 0;
              if (type !== "LINK") {
                link_offset = 100;
              }
              ctx.drawImage(linkdp,
                2530, y_pos - link_offset, w * s, h * s);

              ctx.save();
              ctx.translate(2680, 3610);
              ctx.rotate(Math.PI / 2);


              //              ctx.fillText(json.linkDP, 0, 0);
              //              writeDP(ctx, json.linkDP, 0, 0, 90); 
              writeDP(ctx, json.linkDP,
                { x: -150 - link_offset, y: 20, size: 100, bigsize: 140, stroke: false, color: "white" });
              ctx.font = `bold 90px ${numberFont}`;
              ctx.fillStyle = "white";
              ctx.textAlign = "right";
              ctx.textBaseline = "bottom";


              ctx.font = `40px 'Helvetica'`;
              ctx.textAlign = "center";
              ctx.fillText("DP", -300 - link_offset, -60);
              // how do i make the plus skinnier?
              ctx.font = `100 120px 'Helvetica'`;

              ctx.fillText("+", -300 - link_offset, 40);

              ctx.restore();



            }


            let start_x = 164;
            // name block
            if (true) {
              let scale = 364.2;
              let y = 3550 - 365;
              if (type === "MEGA" || type === "LINK" || !empty(json.linkDP)) {
                y += 500;
              } else if (type === "EGG" || type.startsWith("OPTION") || type.startsWith("TAMER")) y -= 90;
              //  if (type.startsWith("OPTION") || type.startsWith("TAMER")) y += 0; // 40;
              if (type === "ACE" && imageOptions.aceFrame) {
                y += 30;
                start_x -= 4
                scale = 368
              }
              let y_scale = 1;
              let img_name = name_field[col];
              if (type.startsWith("OPTION") || type.startsWith("TAMER")) scale = 305;
              if (type === "EGG") {
                // egg is weirder, needs so much special case 
                y -= 34;
                scale = 365;
                y_scale = 1.03;
              }

              scalePartialImage(ctx, img_name, i, len, scale, start_x, y, 0, y_scale);


              // do the black (white) bar on anything with a trait, or anything with "Lv.*" text
              if (i === len - 1) {
                let skip = false;
                let bar_offset = 273;

                if (type.startsWith("OPTION") || type.startsWith("TAMER")) {
                  skip = true;
                  bar_offset = 252;
                }
                // more special cases for egg, this sucks
                if (type === "EGG") {
                  skip = true;
                  bar_offset = 292 - 14;
                }

                if (has_traits) skip = false;

                // do underline for traits, check st19 arisa because Tamers might need it
                if (!skip) {
                  let bar_img = (colors[0] === "black") ? bottom_property_white : bottom_property_black;

                  let scale = 4.015;
                  if (true) ctx.drawImage(bar_img,
                    162, y + bar_offset,
                    bar_img.width * scale * 0.999,
                    bar_img.height * scale * 1.17) // stretch a little
                }
              }
            }
          }
        }
      } // end multi-color drawing

      // rule text can either be at the very end
      // if digixros && rule are both small, they can be on the same line (BT18-072)
      // if ruletext is short it could be after the effect text, above digixros (BT18-028, BT19-065)
      // sometimes they have the full digixros effect and the rule above it (BT15-012)

      bottom += 800;
      const rule = colorReplace(json.rule, true);
      let xros_text = json.digiXros;
      if (!empty(json.assembly)) xros_text = json.assembly;
      const xros = colorReplace(xros_text, true);
      const baseFontSize = Number(json.imageOptions.fontSize) || 90.5
      const altFontSize = baseFontSize + (Number(json.imageOptions.altFontDelta) || 0);
      let rule_offset = 0;
      let xros_offset = 0;
      let radius = Number(json.imageOptions.bubbleRadius) || 0;
      let cardwidth = 2400;


      if (!empty(xros)) {
        let preview = drawBracketedText(ctx, altFontSize, xros, 300, bottom,
          cardwidth, Number(altFontSize) + Number(imageOptions.lineSpacing), "bubble", radius, true);
        // our text should end at roughly bottom + 
        xros_offset = preview - (bottom + altFontSize * 2);
        console.log(1254, 'x', preview, bottom);
      }
      if (!empty(rule) && !empty(xros)) {
        let rule_start = writeRuleText(ctx, rule, altFontSize, bottom, true);
        let xros_length = ctx.measureText(xros).width;
        let fudge = 260;

        if (300 + xros_length + fudge > rule_start) {
          rule_offset = (Number(altFontSize) * 1.2 + Number(imageOptions.lineSpacing) * 2.0);
        }
      }
      if (!empty(rule)) {
        console.log(1069, "bottom is " + (bottom - xros_offset - rule_offset));
        writeRuleText(ctx, rule, altFontSize, bottom - xros_offset - rule_offset);
      }

      if (!empty(xros)) {
        // BT10-009 EX3-014: shaded box
        // st19-10 solid box
        drawBracketedText(ctx, altFontSize, xros, 300, bottom - xros_offset, cardwidth, Number(altFontSize) + Number(imageOptions.lineSpacing), "bubble", radius);
      }



      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // EVO CIRCLES: only monsters (and tamers, why not) can have evo circles
      if (hasEvo(type)) {

        if (_evos && _evos.length > 0 && (
          _evos[0].color || _evos[0].level || _evos[0].cost)) {

          // BT-14 and up, there is never two evo circles any more (until direct on tamers).


          let evo1_level_costs = _evos.map(e =>
            e.level ? String(e.level).split("/").map(l => ({ level: l, cost: e.cost })) : []
          )
            .reduce((acc, curr) => acc.concat(curr), [])
            .filter((value, index, self) =>
              index === self.findIndex(v => v.level === value.level && v.cost === value.cost)
            );

          for (let j = evo1_level_costs.length - 1; j >= 0; j--) {
            // get the colors for every condition with this level...
            let level = evo1_level_costs[j].level;
            let evo1_cost = evo1_level_costs[j].cost;

            let evo1_colors = _evos
              .filter(e => e.level.includes(level) && e.cost && e.cost === (evo1_cost))
              .map(e => e.color ? e.color.toLowerCase().split("/") : [])
              .reduce((acc, curr) => acc.concat(curr), []);
            j = Number(j);
            let circle_offset = (j) * 380;

            let n_level = parseInt(level);
            const evo1_level = n_level ? "Lv." + level : level;

            let ring = cost_evo;
            if (j > 0) ring = cost_evo_plain;
            ctx.drawImage(ring, offset_x, offset_y + 600 + circle_offset, 440, 440);

            let base = -135; // degrees
            let each = 360 / (evo1_colors.length);

            for (let i in evo1_colors) {
              const my_color = evo1_colors[i];
              i = Number(i);
              let X = offset_x + 130 - 10
              let Y = offset_y + 110 + 600 + circle_offset;

              const imgWidth = 272; // height, too
              const imgHeight = 272 ; // +6 ; // height, too

              const circle = evoImages[my_color];
              const wedge = wedgeImages[my_color];
              const radius = (imgWidth + imgHeight) / 4;
              // TODO: wait for .onLoad()? Or did we.
              let start = base + i * each
              const startAngle = (start * Math.PI) / 180;
              const sweepAngle = (each * Math.PI) / 180;
              ctx.save();
              ctx.beginPath();
              //fudge solid circle into place. 
              // the thing we're overwriting isn't an exact circle and that's making trouble
              const temp_x = -5; // 
              const temp_y = -2;
              X += temp_x;
              Y += temp_y;
              ctx.moveTo(X + radius, Y + radius);
              ctx.arc(X + radius, Y + radius, radius, startAngle, startAngle + sweepAngle);
              ctx.lineTo(X + radius, Y + radius);

              ctx.clip();
              try {
                ctx.drawImage(circle, 0, 0, 291, 291, X, Y, imgWidth, imgHeight);
                if (my_color === 'red') {
                  ctx.globalCompositeOperation = 'color'; 
                  ctx.fillStyle = 'rgba(255, 170, 140, 0.6)';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
                if (my_color === 'blue' || my_color === 'green') {
                  ctx.globalCompositeOperation = 'luminosity'; 
                  ctx.fillStyle = 'rgba(70,70,70, 0.5)';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
                let cx=X+radius;
                let cy=Y+radius;
                circleGlow(ctx, cx, cy, radius * 1.1);

              } catch (e) {
                console.error(1329, "no circle", e);
              }
              ctx.restore();
              X -= temp_x;
              Y -= temp_y;
              try {
                ctx.drawImage(wedge, 0, 0, 291, 291, X - 120, Y - 113, 4.55 * wedge.width, 4.82 * wedge.height);
              } catch (e) {
                console.error(1576, "no wedge", e);
              }
            }

            // how to write the "lv.4" and "TAMER" text in evo circle?
            // many many experiments here 
            ctx.font = `90px Roboto, Helvetica`; //  Roboto`;
            ctx.font = `90px ${numberFont}`;
            ctx.font = `80px AyarKasone, Helvetica`;
            ctx.font = `80px Helvetica`;
            //    ctx.font = `80px MyriadProBold`;

            let levelsize = 75;
            let level_offset = 0;
            if (evo1_level.length > 4) {
              levelsize -= 10;
              level_offset = 10;
            }

            ctx.font = `${levelsize}px 'Hiragino'`; //  Roboto`;

            ctx.lineWidth = 10;

            let [fillColor, strokeColor, border] = textColor(evo1_colors, ctx);

            // what was this clause for? textColor() should handle it
            if (evo1_colors.length === 1 && (evo1_colors[0] === 'yellow' || evo1_colors[0] === 'white')) {
   //           fillColor = 'black';
     //         border = false;
            }
            if (border) {
           //   ctx.font = `75px 'Hiragino'`
              ctx.strokeStyle = strokeColor;
              ctx.lineWidth = 15;
              ctx.strokeText(evo1_level, 340, 845 + circle_offset + level_offset, 180);
            }
            ctx.fillStyle = fillColor; // contrastColor(evo_color);
            ctx.fillText(evo1_level, 340, 845 + circle_offset + level_offset, 180);
            // I *swear* that Helvetica is right for the digit 0, but that's nuts, why would that be different?
            ctx.font = `bold 210px ${numberFont}`;
            if (border) {
              ctx.lineWidth = 10;
                            ctx.lineJoin = "round"
                    ctx.lineWidth = 18;

              ctx.strokeText(evo1_cost, 340, 970 + circle_offset);
            }
            ctx.fillText(evo1_cost, 340, 970 + circle_offset);
          }
        }
      }

            // DRAW NAME BOX MANUALLY, then write name
      if (type === "DUAL") {
          nameBoxShell(ctx, 3220 - 282, colors, optionColors);
          // why is this name outside??
          ctx.font = `italic ${130}px ToppanBunkyExtraBold`; // has curved lowercase l
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          let [fillColor, edgeColor, stroke] = textColor(optionColors);
          ctx.fillStyle = fillColor;
          ctx.strokeStyle = edgeColor;
          ctx.lineWidth = 10;
          let optName = "Option";
          let names = json.name.english.split("/");
          if (names.length > 1) optName = names[1];
          let width = 1650;
          if (stroke) ctx.strokeText(optName, (1480), 3355, width);
          ctx.fillText(optName, (1480), 3355, width);
      }


      let x = 355;
      //playcost. If 0 or more, show that number. Else show egg symbol.
      let playcost = parseInt(json.playCost);

      if (true) {
        let img = undefined;
        if (type === "EGG") img = cost_egg;
        if (playcost >= 0) {
          img = cost;
          if (type.startsWith("OPTION")) img = cost_option;
        }
        if (type === "DUAL") img = cost_dual;

        if (json.playCost.toLowerCase() === "egg") img = cost_egg;
        if (json.playCost.toLowerCase() === "dash") {
          img = cost;
          playcost = "-";
        }
        if (json.playCost.toLowerCase() === "blank") img = cost_blank;
        if (json.playCost.toLowerCase() === "dual") img = cost_dual;
        if (img) {
          ctx.drawImage(img, offset_x, offset_y, 500, 500);
          for (let color of colors) {
            let i = costs[color];
            if (i) ctx.drawImage(i, offset_x, offset_y, 500, 500);
          }
          if (img !== cost_dual && img !== cost_egg) { 
            let cx=380;
            let cy=360;
            circleGlow(ctx, cx, cy);
          }
        }
        let neue_offset = 0;
      //  if (!neue) neue_offset = 20;
        if (type === "DUAL") {
          // always white
          ctx.fillStyle = 'white';
          // show cost in different place
          let size = 180;
          ctx.font = `600 ${size}px ${numberFont}`;
          if (!neue)
            ctx.font = `600 ${size * 1.03}px ${numberFont}`;
          ctx.strokeStyle = '#ffffffb0';        
          ctx.lineWidth = 7;
          ctx.shadowColor = 'white'; // Glow 
          ctx.shadowBlur = 40;    

          ctx.fillText(playcost, x + 152, 3375 + neue_offset);
          ctx.strokeStyle = '#ffffff40';        
          ctx.strokeText(playcost, x + 152, 3375 + neue_offset);
          ctx.shadowBlur = 0;     // Glow intensity
        } else if (playcost >= 0 || playcost === "-") {
          let size = 290
          ctx.font = `600 ${size}px ${numberFont}`;
          if (!neue)
            ctx.font = `600 ${size * 1.11}px ${numberFont}`;

          ctx.fillStyle = 'white';
          if (gold_text) {
            ctx.fillStyle = gold_gradient;
          }
          ctx.fillText(playcost, x + 15, 370 + neue_offset);
        }
      }


      if (type === "ACE" && overflow) {
        ctx.font = `95px MyriadProBold`;

        console.log(2200, json.aceEffect);
        let overflow_match = json.aceEffect.match(/\((.*)\)/s);
        let custom_text = overflow_match && overflow_match[1];
        if (!custom_text || custom_text.length < 4) {
          custom_text = "As this card moves from the field or\n" +
            "under a card to an area other than those, lose " + overflow + " memory.";
        }

        let neg_overflow = "-" + overflow;
        let o_x = 1170, o_y = 3645;
        // fake blur 
        ctx.strokeStyle = 'rgba(200, 200, 200, 0.7)';
        ctx.lineWidth = 22;
        ctx.strokeText(neg_overflow, o_x, o_y);

        ctx.strokeStyle = 'rgba(200, 200, 200, 0.85)';
        ctx.lineWidth = 18;
        ctx.strokeText(neg_overflow, o_x, o_y);

        ctx.strokeStyle = '#eee';
        ctx.lineWidth = 14;
        ctx.strokeText(neg_overflow, o_x, o_y);

        ctx.shadowBlur = 0; // Remove shadow blur for the fill text
        ctx.fillStyle = 'rgba(32, 32, 32, 0.8)'; // '#444';
        ctx.fillText(neg_overflow, o_x, o_y);

        ctx.font = `95px MyriadProBold`;
        //  ctx.font = `90px MyriadProSemibold`;
        // Semibold might be a slightly better match but it means a whole extra font

        ctx.textAlign = 'left';

        let lines = custom_text.split("\n");
        let [line1, line2] = lines;
        let ace_text = [["("], [line1, "italics"]];
        let ace_text2 = [[line2, "italics"], [")"]]

        ctx.fillStyle = 'rgba(255, 254, 254, 1.0)';
        textLine(ctx, ace_text, 1310, 3655, 1400);
        textLine(ctx, ace_text2, 650, 3750, 2120);//, 0.2);


        if (false) {
          ctx.strokeStyle = 'rgba(200, 200, 200, 0.5)';
          ctx.lineWidth = 8;
          ctx.strokeText(overflow, 2370, 3750);


          ctx.strokeStyle = '#eee';
          ctx.lineWidth = 5;
          ctx.fillStyle = '#ddd';
          //        ctx.fillText('lose  4  memory', 1850, 3730);
          ctx.strokeText(overflow, 2370, 3750);
          ctx.fillText(overflow, 2370, 3750);
        }


        // now put it in its second place

      }

      if (hasDP(type)) {
        // dp
        x = 2540;
        y = 410;
        // was 150 300
        writeDP(ctx, json.dp, { x: x, y: y, size: 165, bigsize: 345, stroke: "white", color: "black" });
        ctx.font = `100px 'Helvetica'`;
        ctx.lineWidth = 15;
        ctx.strokeStyle = 'white';
        if (gold_text) {
          ctx.strokeStyle = 'black';
          ctx.fillStyle = gold_gradient;
        }
        ctx.strokeText("DP", x + 130, y - 200);
        ctx.fillText("DP", x + 130, y - 200);

      }
      /////// LEVEL
      if (hasLevel(type)) {
        let level = (json.cardLv === "-" || json.cardLv === undefined) ? "Lv.-" : json.cardLv;
        // roboto preferred
        //        ctx.font = '900 200px "Roboto"'
        ctx.fillStyle = whiteColor(colors[0]);
        let y = 3400;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'bottom';

        y += levelHeight(type);
        y += 100
        if (type === "ACE" && imageOptions.aceFrame) y += 40;
        ctx.font = '900 200px "Big Shoulders Text"'
        ctx.font = '900 170px "ProhibitionRough", "Big Shoulders Text"'
        let x = 250;

        level = (level + "    ").substring(0, 4);
        ctx.font = '170px "ProhibitionRough", "Big Shoulders Text"'
        ctx.fillText(level[0], x, y - 10);
        x += ctx.measureText(level[0]).width;

        ctx.font = '900 130px "ProhibitionRough", "Big Shoulders Text"'
        ctx.fillText(level[1], x, y - 13);
        x += ctx.measureText(level[1]).width;

        ctx.font = '900 143px "ProhibitionRough", "Big Shoulders Text"'
        ctx.fillText(level[2], x, y - 18);
        x += ctx.measureText(level[2]).width + 10;

        ctx.font = '250px "ProhibitionRough", "Big Shoulders Text"'
        ctx.fillText(level.substring(3), x, y);
        x += ctx.measureText(level[0]).width;

      }

      //// NAME 
      let delta_y = 0;
      let name_delta_y = 0;
      switch (type) {
        case "OPTION":
        case "OPTIONINHERIT":
        case "TAMER":
        case "EGG":
        case "TAMERINHERIT": name_delta_y = -125; break;
        case "LINK":
        case "MEGA": name_delta_y = 500; break;
        case "MONSTER": break;
        case "ACE": if (imageOptions.aceFrame) delta_y = 30; break;
        case "DUAL": name_delta_y = /*(862 - 140) */ 500 - (682) - 100; break;
        default: alert(1);
      }
      if (!empty(json.linkDP)) name_delta_y = 500;
      if (!has_traits) name_delta_y += 30;
      delta_y += name_delta_y;

      // name
      try {
        const name = json.name.english.split("/")[0];        
        let ace_offset = (type === "ACE") ? -ace_logo.width / 2 : 0;
        const maxWidth = 1600 + ace_offset * 2;

        const initialFontSize = 200;
        const namefontSize = fitTextToWidth(ctx, name, maxWidth, initialFontSize, 180);
        // PF Das Grotesk Pro Bold is the actual font but $$
        //ctx.font = `bold ${fontSize}px Roboto`; // better looking I
        //        ctx.font = `700 ${fontSize}px Schibsted Grotesk`; // has curved lowercase l
        ctx.font = `${namefontSize}px ToppanBunkyExtraBold`; // has curved lowercase l
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        let [fillColor, edgeColor, stroke] = textColor(colors, ctx);
        ctx.fillStyle = fillColor;

        ctx.lineWidth = 30; // Border width
        ctx.strokeStyle = edgeColor;
        let actualWidth = ctx.measureText(name).width;
        let scale = (maxWidth) / actualWidth;
        let endWidth = Math.min(maxWidth, actualWidth);
        if (scale > 1) scale = 1;
        // at  a certain point we should do multiple lines
        ctx.save();
        ctx.scale(scale, 1);
        let name_line = 3328
        if (stroke) {
          ctx.lineWidth = 20; // Border width
          ctx.strokeText(name, (1480 + ace_offset) / scale, name_line + delta_y);
        }
        ctx.lineWidth = 2; // Border width
        ctx.fillText(name, (1480 + ace_offset) / scale, name_line + delta_y);
        ctx.restore();


        if (type === "ACE") {
          let end = endWidth / 2;
          ctx.drawImage(ace_logo, 1480 + ace_offset + end + 10, name_line + delta_y - 95);
        }
      } catch { };

      // card number
      const id = json.cardNumber;
      ctx.textAlign = 'right';
      ctx.fillStyle = contrastColor(colors[colors.length - 1]);
      // maybe this should be bold condensed?
      ctx.font = `bold 100px ${numberFont}`;
      // this looks okay on mobile, but not enough weight on desktop
      ctx.font = `bold 100px 'XXXNeue Helvetica Condensed BQ', ${numberFont}`;


      // Helvetica seems basically right but needs to be made skinny
      // ToppanBunkyExtraBold has serifs on 1 now??
      // myriadprobold wrong on 7 6 1
      // asimov has wrong 6
      // ayarkasone has the right 1 but the wrong 5
      // levetica and arial may be too plain? or not.
      // not roboto because the 6 needs a hook
      // fallingsky ihas the wrong 1

      ctx.fillText(id, 2740, 3300 + delta_y);

      ////// right under card number, put circle and block

      CircleAndBlock(ctx, colors[colors.length - 1], json.rarity, json.block, 2740 - 150, 3300 + delta_y);

      // traits: form, attribute, type
      ctx.textAlign = 'right';
      let form = json.form || '';
      let attribute = json.attribute || '';
      let c_type = json.type || '';
      // todo don't show when all blank
      let a_traits = [];

      if (!empty(form)) a_traits.push(`${center(form)}`);
      if (!empty(attribute)) a_traits.push(`      ${center(attribute)}      `);
      if (!empty(c_type)) a_traits.push(`  ${c_type}     `);
      let traits = a_traits.join("|");
      ctx.fillStyle = whiteColor(colors[0]);
      if (type.startsWith("OPTION") || type.startsWith("TAMER")) {
        delta_y += 18;
      }
      if (type === "MEGA") {
        //        delta_y += 50;
      }
      if (type === "EGG") {
        delta_y += 10;
      }

      ctx.font = `60px Hiragino`;
      ctx.fillText(traits, 2750, 3497 + delta_y)// * 0.9);

      ///// MAIN TEXT 
      let y_line = bottom - 640; // set above for effectbox / rule

      //      let b = Number(imageOptions.baselineOffset);
      let so = Number(imageOptions.specialOffset);
      y_line -= Number(imageOptions.baselineOffset);

      //console.log(1149, b, imageOptions.baselineOffset, y_line);
      ctx.font = `bold 90px Arial`;
      ctx.textAlign = 'start';
      ctx.textBaseline = 'bottom'; // Align text to the bottom


      const fontSize_n = Number(altFontSize); // should already be a number.
      // DNA evo and special evo appear above the effect line
      const dna_evo = json.dnaEvolve || json.dnaDigivolve; // colorReplace is inside drawBracketedText
      const spec_temp = json.specialEvolve || json.specialDigivolve;
      const burst_evo = json.burstEvolve || json.burstDigivolve;
      const spec_evo = colorReplace(spec_temp, true);
      const delta = fontSize_n + so;
      let special_baseline = y_line;
      console.log(1277, special_baseline, y_line, (fontSize_n + so))
      if (!empty(dna_evo)) {
        special_baseline -= (delta);
        drawBracketedText(ctx, fontSize_n, dna_evo, 270, special_baseline, 3000 * 1, Number(fontSize_n) + Number(imageOptions.lineSpacing), "dna", radius);
        special_baseline -= (delta * .5);
      }
      if (!empty(spec_evo)) {
        special_baseline -= (delta);
        drawBracketedText(ctx, fontSize_n, spec_evo, 270, special_baseline, 3000 * 1, Number(fontSize_n) + Number(imageOptions.lineSpacing), "bubble", radius);
      }
      if (!empty(burst_evo)) {
        special_baseline -= (delta * 0.5); // burst bubble is twice as big
        drawBracketedText(ctx, fontSize_n, burst_evo, 270, special_baseline, 2500, Number(fontSize_n) + Number(imageOptions.lineSpacing), "doublebubble", radius);
      }

      let effect = json.effect;
      ctx.fillStyle = 'black';

      y_line += 80;
      //      if (type === "MONSTER") y_line += 180;

      if (effect && effect !== "-") {
        effect = colorReplace(effect, true);
        y_line = drawBracketedText(ctx, baseFontSize, effect,
          //wrapText(ctx, effect, // + effect, 
          250, y_line,
          2455 + 100,
          Number(baseFontSize) + Number(imageOptions.lineSpacing), type.startsWith("OPTION") ? "effect-option" : "effect",
          radius,
          false
        );
      }


      // evo effect
      ctx.textAlign = 'start';
      ctx.textBaseline = 'bottom'; // Align text to the bottom


      console.log("a", evo_effect);
      if (type === "MEGA") {
        // no security text
      } else if (type === "LINK" || !empty(json.linkDP)) {
        let req = json.linkRequirement;
        let effect = json.linkEffect;
        let delta_x = -220; let delta_y = -200;
        if (type.startsWith("OPTION") || type.startsWith("TAMER")) {
          delta_y -= 50;
        }
        //let shrink = 1000;
        if (!empty(req)) {
          // instead of 3000, width of 2700 to save room for link-DP-thingy

          // (alias) drawBracketedText(ctx: any, fontSize: any, text: any, x: any, y: any, _maxWidth: any, lineHeight: any, extra: any, radius: any, preview?: boolean): any
          // ctx                
          drawBracketedText(ctx, altFontSize, req, 300, 3740 + delta_y * 2, 3000, Number(altFontSize) + Number(imageOptions.lineSpacing), "bubble");
        }
        // shrink is not working, we're ignoring max_width
        //let max_width = 2500 - 400 - delta_x * 2 - shrink;
        drawBracketedText(ctx, baseFontSize, effect,
          700 + delta_x * 2, 3740 + delta_y * 2 + 150,
          2200, Number(baseFontSize) + Number(imageOptions.lineSpacing), "effect", radius);
      } else {
        let sec_effect = (evo_effect && evo_effect !== "-") ? evo_effect : json.securityEffect;
        if (empty(sec_effect)) sec_effect = json.optionCardEffect;
        sec_effect = colorReplace(sec_effect, true);

        //ctx.fillStyle = 'red';
        let delta_x = delta_y;
        let shrink = 0;
        if (type === "ACE") {
          delta_x -= 60; delta_y += 100;
        } else if (type.startsWith("OPTION") || type.startsWith("TAMER") || type === "EGG") {
          delta_x = 0; delta_y = -50;
        } else if (type.startsWith("DUAL")) {
          delta_x = -250; delta_y = -70; 
        } else {
          delta_x = 0; delta_y = 0;
        }
        let max_width = 2500 - 400 - delta_x * 2 - shrink;
        // standard "effect" text is white with black border
        // "option" (unused here) is black with minimal border
        // "black effect" is black with black/no border
        // "reverse effect 
        let style = "effect";       
        let [fillColor, edgeColor, stroke] = textColor(colors);
        style = `custom[${fillColor},${edgeColor},${stroke}]`;
        drawBracketedText(ctx, baseFontSize, sec_effect,
          700 + delta_x * 2, 3740 + delta_y * 2,
          max_width, Number(baseFontSize) + Number(imageOptions.lineSpacing), style, radius);
        const dualEffect = json.dualEffect;
        if (!empty(dualEffect)) {
          let fontSize = 80;
          let artsMatch = dualEffect.match(/\[(.*)\]\s*\((.*)\)/s);
          let artsText = artsMatch && artsMatch[2];
          if (!artsText || artsText.length < 3) {
            artsText = "Instead of trashing after use, your cards may digivolve into this card without paying the cost";
          }
          artsText = " " + artsText;
          console.log(3216, artsMatch);
          let keyword = artsMatch && artsMatch[1];
          if (!keyword) keyword = "Arts Digivolve";
          keyword = "[" + keyword + "]";
          delta_x += 50; delta_y += 20;
          const x = 700 + delta_x * 2.5;
          const y = 4100 + delta_y * 1.5;
          drawBracketedText(ctx, fontSize, keyword,
            x, y,
            max_width,
            Number(baseFontSize) + Number(imageOptions.lineSpacing),
             "effect", radius);

          let text = [["("], [artsText, "italics"], [")"] ];
          ctx.fillStyle = 'rgba(255, 254, 254, 1.0)';
          // this x,y is messed up, because it's scaled
          const len = keyword.length * 30;
          textLine(ctx, text, 190 + len, 4020, 2600 - len);
          }


      }

      console.log(1879.3, pauseDraw.current);
      updateBigCanvas();

      // last try for pen
    } /// end afterLoad
    console.log(2150, "3");
    /*
    if (false)
      if (isSelecting) {
        ctx.strokeStyle = 'red';
        ctx.lineWidth = 30;
        console.log(1026, "x", startX, startY, endX - startX, endY - startY);
 
        ctx.strokeRect(startX * 2977 / 355,
          startY * canvas.height / 499,
          (endX - startX) * 2977 / 355,
          (endY - startY) * canvas.height / 499
        )
      }
        */


    let evo_circle_colors = [];
    if (_evos) {
      evo_circle_colors = ['red', 'blue', 'yellow', 'green', 'black', 'purple', 'white', 'all'];
    }
    console.log(2117, imageOptions);
    console.log(2118, imageOptions.effectBox);
    const effectFrames = imageOptions.effectBox ? Array.from({ length: len }, () => new Image()) : [];

    // N for basic style frame, [npo custom iage], 1 per color, 2 per evo circle, 1 per effect box
    let imagesToLoad = cardframes.length + 0 + frameImages.length + 2 * (evo_circle_colors.length) + effectFrames.length;
    console.log(817, frameImages.length, _evos && _evos.length);
    let imagesLoaded = 0;

    await new Promise((resolve) => {
      const checkAllImagesLoaded = (text, failure) => {
        imagesLoaded++;
        //console.info(771, failure ? "IMAGE FAILED" : "image loaded,", imagesLoaded, imagesToLoad, text);
        if (imagesLoaded === imagesToLoad) { // Change this number based on the number of images
          // Set the canvas dimensions  
          afterLoad();
          resolve();
        }
      };

      for (let i = 0; i < effectFrames.length; i++) {
        effectFrames[i].src = effectboxes[colors[i]];
        effectFrames[i].onload = function () { checkAllImagesLoaded("box" + i); }
        effectFrames[i].onerror = function () { checkAllImagesLoaded("box" + i, true); }

      }

      for (let f of frameImages) {
        f.onload = function () { checkAllImagesLoaded(f.src); }
        f.onerror = function () { checkAllImagesLoaded(f.src, true); }
      }

      for (let color of ['red', 'blue', 'yellow', 'green', 'black', 'purple', 'white', 'all']) {
        let my_color = color;
        let evoI = new Image();
        evoImages[my_color] = evoI;
        // do we seriously need to set the .src here?
        evoI.src = new_evo_circles[my_color]
        evoI.onload = function () { checkAllImagesLoaded(`evo circle  ${my_color}`); }
        evoI.onerror = function () { checkAllImagesLoaded(`evo circle  ${my_color}`, true); }
        let wedgeI = new Image();
        wedgeImages[my_color] = wedgeI;
        wedgeI.src = new_evo_wedges[my_color]
        wedgeI.onload = function () { checkAllImagesLoaded(`evo wedge  ${my_color}`); }
        wedgeI.onerror = function () { checkAllImagesLoaded(`evo wedge ${my_color}`, true); }
      }
      for (let i in cardframes) {
        shellImages[i] = new Image();
        shellImages[i].src = cardframes[i];
        shellImages[i].onload = shellImages[i].onerror = function () { checkAllImagesLoaded(`shell src  ${i} ${shellImages[i].src}`); }
      }


      switch (type) {
        case "OPTION":
        case "OPTIONINHERIT": array = options; break;
        // how is outlines_tamer different from outlines_egg??
        case "TAMER":
        case "TAMERINHERIT": array = has_cost ? outlines_tamer : outlines_tamer_nocost; break;
        // Is there any way to indicate we should use the no_cost egg background??
        case "EGG": array = has_cost ? outlines_egg : outlines_egg; break;
        case "MONSTER": break;
        case "MEGA": break;
        case "ACE": break;
        case "LINK": break;
        case "DUAL": array = []; break;
        default: alert(4);
      }


      if (type.startsWith("OPTION")) {
        frameImages[0].src = has_cost ? outline_option : outline_option_nocost;
      } else {
        for (let i = 0; i < frameImages.length; i++) {
          frameImages[i].src = array[colors[i]];
        }
      }
      console.log(906, `sources set ${imagesToLoad} loaded ${imagesLoaded} base: ${!!baseImg}`);

    });


    if (pauseDraw.current > 1) {
      console.debug("triggering redraw " + newRedraw);
      pauseDraw.current = 0;
      setNewRedraw(newRedraw + 1);
      console.debug("triggered redraw " + newRedraw);
    } else {
      try {
        let obj = JSON.parse(jsonText[currentIndex]);
        if (obj.length > 1) {
          // we only need this if we have multiple cards
          console.log(2734.1, "cardIndex is " + cardIndex);
          // doing this every time could be expensive
        }
      } catch (e) {
        console.error("update", e);
      }


      pauseDraw.current = -1;
    }
    // end draw
  }, [foreImg, backImg, jsonText, selectedOption, doDraw, currentIndex,
    initImageOptions, cardIndex,
    newRedraw,
    //, endY, isSelecting, startX, startY, 
  ]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const bigCanvas = miniTracker.current;
    for (const c of [canvas, bigCanvas]) {
      if (!c) continue;
      if (c.width !== 2977) {
        c.width = 2977;
        c.height = 4158 - 17;
      }
    }

    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    setupRoundedCorners(ctx, canvas.width, canvas.height, 15);

    if (doDraw)
      draw(canvas, ctx);

  }, [
    foreImg,
    jsonText,
    imageOptions, selectedOption,
    doDraw,
    draw]);

  const handleExport1 = async () => {
    document.getElementById("download1").disabled = true;
    let json = JSON.parse(jsonText[currentIndex]);
    let json1 = json[cardIndex];
    try {
      let name = json1.name.english;
      name = name.replace(/[^a-zA-Z0-9]+/g, '-') + ".png";
      exportOneImage(name);
    } catch (e) {
      console.error(e);
    }
    document.getElementById("download1").disabled = false;

  }

  const handleExport = async () => {

    document.getElementById("downloadall").disabled = true;
    let name = 'custom-card.png';
    let json = {};
    try {
      json = JSON.parse(jsonText[currentIndex]);
    } catch (e) {
      console.error(e);
      document.getElementById("downloadall").disabled = false;

      return;
    }
    if (Array.isArray(json) && json.length > 1) {
      const zip = new JSZip();
      for (let i = 0; i < json.length; i++) {
        const canvas = canvasRefs.current[i];
        const dataUrl = canvas.toDataURL('image/png');
        const base64Data = dataUrl.split(',')[1]; // Get base64 part
        let filename = `image${i + 1}`;
        try {
          filename = json[i].name.english;
          filename = filename.replace(/[^a-zA-Z0-9]+/g, '-');

          if (json[i].id) filename = json[i].id; // what is this for?
        } catch { }
        filename += ".png";
        zip.file(filename, base64Data, { base64: true });
      }
      const zipBlob = await zip.generateAsync({ type: 'blob' });
      saveAs(zipBlob, 'images.zip');
    } else {
      try {
        let json1 = json[0];
        name = json1.name.english;
        name = name.replace(/[^a-zA-Z0-9]+/g, '-') + ".png";
        exportOneImage(name);
      } catch (e) {
        console.error(e);
      }
    }
    document.getElementById("downloadall").disabled = false;

  }

  const exportOneImage = (name) => {
    if (!name) name = 'custom-card.png';
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    setupRoundedCorners(ctx, canvas.width, canvas.height, 15);
    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = name;
    link.click();
  };

  const handleUndo = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const invite = 'https://discord.gg/THzb53dTDW';
  let button = (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
      <button
        onClick={handleUndo}
        style={{ backgroundColor: showJson === 1 ? 'lightblue' : 'white', marginRight: 'auto' }}
      >
        Undo
      </button>

      <button
        onClick={() => setShowJson(1)}
        style={{ backgroundColor: showJson === 1 ? 'lightblue' : 'white' }}
      >
        Raw
      </button>
      <button
        onClick={() => setShowJson(0)}
        style={{ backgroundColor: showJson === 0 ? 'lightblue' : 'white' }}
      >
        Text Fields
      </button>
      <button
        onClick={() => setShowJson(2)}
        style={{ backgroundColor: showJson === 2 ? 'lightblue' : 'white' }}
      >
        Free Form
      </button>

    </div>
  );
  let z = zoom;
  if (!z) z = 100;
  if (z < 25) z = 25;
  if (z > 300) z = 300;
  const width = (355 * z / 100) || 355;
  const height = (499 * z / 100) || 499;

  /*
  const handleMouseDown = (e) => {
    setIsSelecting(true);
    const rect = canvasRef.current.getBoundingClientRect();
    setStartX(e.clientX - rect.left);
    setStartY(e.clientY - rect.top);
  };
 
  const handleMouseMove = (e) => {
    if (!isSelecting) return;
    const rect = canvasRef.current.getBoundingClientRect();
    setEndX(e.clientX - rect.left);
    setEndY(e.clientY - rect.top);
  };
 
  const handleMouseUp = () => {
    if (!isSelecting) return;
    setIsSelecting(false);
    const width = ((endX - startX) / 355) * 100;
    const height = ((endY - startY) / 499) * 100;
    const x = (startX / 355) * 100;
    const y = (startY / 499) * 100;
 
    setImageOptions(prev => ({
      ...prev,
      ess_x_pos: x,
      ess_y_pos: y,
      ess_x_end: x + width,
      ess_y_end: y + height
      //        rectangleCoordinates: { x, y, width, height }
    }));
    console.log(1768, 'Rectangle Coordinates (%):', { x, y, width, height });
  };
 
  removed from <canvas />?
  onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
 
*/



  // insert into place? re-order?
  const addCard = () => {
    let json_t = jsonText[currentIndex];
    try {
      // could just edit json text?
      let obj = JSON.parse(json_t);
      // make newcard copy of current card, instead of empty card
      let newcard = JSON.parse(jsonText[currentIndex])[cardIndex];
      obj.push(newcard);
      canvasRefs.current.push(null);
      json_t = JSON.stringify(obj, null, 2); // stringify it back
      updateJson(json_t);
    } catch (e) {
      console.error("can't add card:", e);
    }
  }

  const handleCanvasClick = (index) => {
    setCardIndex(index);
  }

  const handlePrev = () => {
    setCardIndex(cardIndex - 1);
  }

  const handleNext = () => {
    setCardIndex(cardIndex + 1);
  }

  function debounce(fn, delay = 150) {
    let timeout;

    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }
  
  const handleTextareaChangeDB = debounce(handleTextareaChange,150);
  const handleFreeformChangeDB = debounce(handleFreeformChange,400);




  let json_t = jsonText[currentIndex];
  let obj;
  try {
    obj = JSON.parse(json_t);
  } catch { }
  let debug = new URLSearchParams(window.location.search).get("debug") === '1';

  jsonToFields(json_t);

  return (
    <table>
      <tbody>
        <tr>
          <td width={"25%"} valign={"top"}>
            <div style={{ overflowY: "scroll", maxHeight: "600px" }}>
              <RadioGroup selectedOption={selectedOption} handleOptionChange={handleOptionChange} />
              {button}
              <br />
              {(showJson === 1) ? (

                <textarea cols={40} rows={25}
                  value={jsonText[currentIndex]}
                  onChange={(e) => handleTextareaChangeDB(e.target.value)}

                //           onChange={(e) => handleTextAreaChange(e.target.value)}
                />
              ) : (showJson === 0) ? (
                <div>
                  <table style={{ maxWidth: "300px" }}>
                    {!flattenedJson ? (<tr><td>Error in JSON, try again <br /> {jsonerror} </td></tr>
                    ) :
                      Object.entries(flattenedJson).filter(([key, value]) => !key.includes("imageOptions")).map(([key, value]) =>
                        <tr>
                          <td key={key}>
                            <label>{key}: </label>
                          </td>
                          <td>
                            {key.match(/effect/i) || key.match(/burst/) ? (
                              <textarea
                                value={formData[key] ?? value}
                                onChange={(e) => handleInputChange(key, e.target.value)} />) : (
                              <input
                                value={formData[key] ?? value}
                                onChange={(e) => handleInputChange(key, e.target.value)} />)
                            }
                          </td>
                          {key === "evolveCondition.0.color" && (
                            <td style={{ whiteSpace: "nowrap" }}>
                              <button onClick={() => pushEvoCond(json_t)}>+</button>
                              <button onClick={() => popEvoCond(json_t)}>-</button>
                            </td>)}
                        </tr>
                      )}
                  </table>
                </div>
              ) : (<form>
                <textarea onChange={(e) => handleFreeformChangeDB(e.target.form)} defaultValue={freeform} name="free" cols={40} rows={25} /><br />
              </form>)}
            </div>
          </td>
          <td width={"25%"} valign={"top"}>
            <div>
              {canvasRefs.current.map((_, i) => (
                <canvas
                  id={"cardImage" + i + "-" + canvasRefs.current.length}
                  ref={(node) => {
                    if (i === cardIndex) {
                      canvasRef.current = node;
                    }
                    canvasRefs.current[i] = node;
                  }}
                  key={i}
                  onClick={() => handleCanvasClick(i)} // Anonymous function passes the index
                  style={{
                    border: (i === cardIndex) ? "2px solid #000000" : "",
                    borderColor: 'red',
                    width: (true ? 297 / 4 : width) + 'px',
                    height: (true ? 414 / 4 : height) + 'px',
                    backgroundColor: '#eef',
                    borderRadius: '5px',
                    overflow: 'hidden',
                    display: canvasRefs.current.length > 1 ? '' : 'none',
                    fontVariantLigatures: "none",
                  }}
                />
              ))}
              <canvas
                id={"cardMain"}
                ref={miniTracker}
                key={9999}
                style={{
                  width: (width) + 'px',
                  height: (height) + 'px',
                //  backgroundColor: '#eef',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  fontVariantLigatures: "none",
                }}
              />

              <br />
              <label>Zoom: <input type="number" style={{ width: "50px" }} name="zoom" value={zoom} onChange={updateZoom} />% </label>


            </div>
          </td>
          <td width={"25%"} valign={"top"}>
            {
              true || (<p>HelveticaNeue may not be loaded.</p>)
            }

            <div>
              <button onClick={addCard}>Add Card</button>
              {obj && obj.length > 1 && (
                <button onClick={handlePrev} disabled={cardIndex === 0}>Prev</button>
              )}
              {obj && obj.length > 1 && (
                <button onClick={handleNext} disabled={cardIndex >= obj.length - 1}>Next</button>
              )}
              {obj && obj.length > 1 && (
                <span>
                  <button onClick={null} disabled={true}>Delete</button>
                </span>
              )}
            </div>


            <div>
              <div>
                <label>Choose background image:
                  <input type="file" onChange={(e) => loadUserImage(e, false)} />
                </label>
                <button title="Plain White" onClick={setWhite}>W</button>
                <button title="Transparent"      onClick={setTrans}>T</button>
                {debug && (<button onClick={() => handleUpload(backImg, "backgrounds")}>upload background (if logged in)</button>)}
              </div>
              {true && <ImageBrowser folder="backgrounds" foregrounds={0} onSelectImage={handleSelectImage} />}
            </div>
            <br />
            Choose foreground image:
            <input type="file" onChange={(e) => loadUserImage(e, true)} />
            {true && <ImageBrowser folder="foregrounds" foreground={1} onSelectImage={handleSelectImage} />}
            {debug && (<button onClick={() => handleUpload(foreImg, "foregrounds")}>upload foreground (if logged in)</button>)}

            <hr />
            <button onClick={draw2}>Force Draw</button>
            <br />
            <button id="download1" onClick={handleExport1}>Download Image</button>
            {obj && obj.length > 1 && (
              <button id="downloadall" onClick={handleExport}>Download All...</button>
            )}
            <br />
            <SaveState jsonText={jsonText[currentIndex]} image_save_fn={() => { handleUpload(backImg, "backgrounds"); handleUpload(foreImg, "foregrounds") }} />
            <br />
            {obj && obj.length > 1 && (
              <span>
                <label>index: <input type="number" style={{ width: "50px" }} name="jsonIndex"
                  value={cardIndex} onChange={(e) => { let n = e.target.value; if (n >= 0 && n < obj.length) setCardIndex(Number(e.target.value)); jsonToFields(jsonText[currentIndex]) }} /> </label>
              </span>
            )}
            {/*          --- OR ---
          <br />
          <input
            type="text"
            name="url"
            placeholder="Enter image URL"
            value={imageOptions.url}
            // onChange={(e) => setImageUrl(e.target.value)}
            onChange={updateImg}
          />
          <br />
          <button onClick={loadImageFromUrl}>Load Image from that URL</button>
          */}
            {
              flattenedJson && Object.entries(flattenedJson).filter(([key, value]) => key.includes("imageOptions.")).map(([k, v]) => [k, v, k.split(".")[1]]).map(([key, value, label]) =>
                <tr>
                  <td key={label}>
                    <label for={label}>{settingText(label)}: </label>
                  </td>
                  <td>
                    <input type={(typeof (value) === "boolean") ? "checkbox" : "number"}
                      value={formData[key] ?? value}
                      checked={value}
                      id={label}
                      onChange={(e) => handleInputChange(key, e.target.value, typeof (value), e.target.checked)} />
                  </td>
                </tr>
              )}
            {   /*         xy_pos, xy_scale are positing & scale for main image, in percent
            <br />
            ess_xy_pos ess_xy_end are corners of box for ess image,*/}
            { /*
            Offset (in percent):
            X: <input type="number" style={{ width: "50px" }} name="x_pos" value={imageOptions.x_pos} onChange={updateImg} />
            Y: <input type="number" style={{ width: "50px" }} name="y_pos" value={imageOptions.y_pos} onChange={updateImg} />
            <br />
            Fill size (in percent):
            X: <input type="number" style={{ width: "50px" }} name="x_scale" value={imageOptions.x_scale} onChange={updateImg} />
            Y: <input type="number" style={{ width: "50px" }} name="y_scale" value={imageOptions.y_scale} onChange={updateImg} />
            <hr />
            ESS start (in percent):
            X: <input type="number" style={{ width: "50px" }} name="ess_x_pos" value={stringRound(imageOptions.ess_x_pos)} onChange={updateImg} />
            Y: <input type="number" style={{ width: "50px" }} name="ess_y_pos" value={stringRound(imageOptions.ess_y_pos)} onChange={updateImg} />
            <br />
            ESS end (in percent):
            X: <input type="number" style={{ width: "50px" }} name="ess_x_end" value={stringRound(imageOptions.ess_x_end)} onChange={updateImg} />
            Y: <input type="number" style={{ width: "50px" }} name="ess_y_end" value={stringRound(imageOptions.ess_y_end)} onChange={updateImg} />
            <br />
                */}
            {/* isSelecting ? "TRACE" : "(dragging  rectangle temporarily disabled)" */}
            <hr />
          </td>
          <td width={"25%"} valign={"top"}>
            <GoogleAuth />

            <button onClick={() => sample(0)}> Sample Egg </button><br />
            <button onClick={() => sample(5)}> Sample Monster </button><br />
            <button onClick={() => sample(1)}> Sample Mega </button><br />
            <button onClick={() => sample(2)}> Sample ACE </button><br />
            <button onClick={() => sample(6)}> Sample Link </button><br />
            <button onClick={() => sample(3)}> Sample Option </button><br />
            <button onClick={() => sample(4)}> Sample Tamer </button><br />
            <button onClick={() => sample(7)}> Sample Dual (testing) </button><br />
            <button onClick={() => sample(-1)}> All (Experimental) </button><br />
            <p />
            <span>For now using these formatting hints while we figure out the best way:</span>
            <p>
              To have colors replaced by circles, put the color in parentheses.
            </p>
            <p> Put《text》in this peculiar demarkers to force the text to dark blue.</p>
            <p> Put ⟦text⟧ in these crazy brackets to force the text to blue.</p>
            <p> Put ⸨text⸩ in these funky parens to force the text to green.</p>
            <p> Put text that would otherwise be blue in parens to make it purple, like ⟦(test)⟧ or [(Five Times Per Turn)].</p>
            <p> "Force Draw" may be needed in weird circumstances. </p>
            <p>You can override the version and URL in the credits by setting an artist name (even making it one space)</p>
          </td>
        </tr>
        <tr style={{ fontSize: "smaller" }} >
          <td width={"30%"} style={{ fontSize: "smaller" }}>
            Version {version} {latest}
            <p style={{ fontFamily: "ToppanBunkyExtraBold" }}>Ask support or request features over on <a href={invite}>Discord</a>.</p>
            <p style={{ fontFamily: "ProhibitionRough" }}><a href="./fontguide.html">FONT GUIDE</a> &nbsp; &nbsp;  <a href="./roadmap.txt">roadmap</a></p>
            <p style={{ fontFamily: "Helvectica" }}>DUAL frames courtesy of <a href="https://github.com/rlv-ab">@rlvvmc</a></p>
            <p style={{ fontFamily: "Roboto" }}>Some modern templates from <a href="https://www.reddit.com/r/DigimonCardGame2020/comments/14fgi6o/magic_set_editor_custom_card_new_template_bt14/">Weyrus and FuutsuFIX</a> based on work by Eronan.</p>
            <p style={{ fontFamily: "Anago-Medium" }}>One or more fonts from <a href="https://www.onlinewebfonts.com/icon">onlinewebfonts</a> licensed by CC BY 4.0</p>
            <p style={{ fontFamily: "AyarKasone" }}> More templates from <a href="https://digi-lov.tumblr.com/post/748763635923435520/digimon-card-template">Digi-Lov</a></p>
            <p style={{ fontFamily: "FallingSky" }}>Shout out to pinimba, Zaffy, and Digimoncard.io who kept this dream alive in previous years.</p>
            <p style={{ fontFamily: "Asimov" }}> Classic templates originally came from Quietype on WithTheWill.</p>

            Check out my <a href="https://digi-viz.com/">other UI project</a>, beta-testers wanted!
            <br />
            <br />
            <br />
            <br />

          </td>
          <td colSpan={3}>
            <img src={banner} alt={"Digi Viz Card Creator"} style={{ width: "700", height: "224px", transform: "rotate(-1deg)", zIndex: -3 }} />
          </td></tr>
      </tbody>
    </table >

  );
}

export default CustomCreator;

